import React, { useEffect, useState, useContext, useCallback, useRef, useMemo } from 'react'
import Layout from '../Layout'
import SearchAuctionList from '../../../Component/Search/SearchAuctionList'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import { useHistory, NavLink, Link } from 'react-router-dom'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import './home.css'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { handleRedirectInternal, mapData } from '../../../Product/common/components'
import { Box, Button, ListItem, Tab, Tabs, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import Loaders from '../../../Product/components/molecules/Loaders'
import jsonp from 'jsonp'
import AlertContext from '../../../Product/context/alert/alertContext'
import queryString from 'query-string'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import GridProduct from '../../../Component/ProductCard/gridProduct'
import { messageHandler } from '../../../Product/common/socketHandler'
import { socket, socketAuction } from '../../../Product/common/socket'
import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react/swiper-react'
import 'swiper/swiper-bundle.css'
import { EffectCoverflow, Navigation, Autoplay, Pagination } from 'swiper'
import Slider from 'react-slick'
import MultisellerListCard from '../../../Component/ProductCard/MultisellerListCard'
import ReactHtmlParser from 'react-html-parser'
import id from 'date-fns/locale/id'
import Reviews from './review'
import FilterPanel from '../../../Product/components/organisms/FilterPanel'
import { useFormik } from 'formik'
import { ReactGoogleReviews } from 'react-google-reviews'
import 'react-google-reviews/dist/index.css'
import item1 from '../../../assets/images/BANNER01.png'
import item2 from '../../../assets/images/BANNER02.png'
import item3 from '../../../assets/images/BANNER03.png'
import item4 from '../../../assets/images/BANNER04.png'
import schedulePickupContext from '../../../Product/context/plugin/schedulePickup/schedulePickupContext'
import WorkingHours from '../WokringHours'
import Popup from '../../../Product/components/organisms/Popup'
import axios from 'axios'
import { useAuctionTerms } from '../AuctionTerms/useAuctionTerms'
import WizardTermsPopup from '../AuctionTerms/wizardTermsPopup'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import { useMediaQuery } from 'react-responsive'

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Typography>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `home-auctions-${index}`,
        'aria-controls': `home-auctions-tabpanel-${index}`,
    }
}

const Home = (props) => {
    const { user } = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const productContext = useContext(ProductContext)

    const {
        search_allauctions,
        getAllSearchAuctions,
        search_allproducts,
        getAllSearchProducts,
        getAllSearchItems,
        productLocalState,
        setState: setLocalState,
        clearResponse_search_details,
    } = productContext
    const { getAllTimings, all_timings } = useContext(schedulePickupContext)
    const { setAlert } = alertContext
    const sessionTimeOutRef = useRef(null)
    const authContext = useContext(AuthContext)
    const { isAuthenticated } = authContext
    const history = useHistory()
    const [loading, setLoading] = useState(true)
    const [loading_buynow, setLoadingBuynow] = useState(true)

    const [viewProduct, setViewProduct] = useState([])
    const [buyNowProduct, setBuyNowProduct] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [value, setValue] = useState(0)
    const [inpData, setinpData] = useState('')
    const [filterValues, setFilterValues] = useState([])
    const [totalItems, setTotalItem] = useState(0)
    const [allLocations, setAllLocations] = useState({})

    const [viewAuction, setViewAuction] = useState([])
    const [tabValue, setTabValue] = useState(0)
    const containerRef = useRef(null)
    const [cardWidth, setCardWidth] = useState(0)
    const now = new Date()
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }
    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)

    const [slidesToShow, setSlidesToShow] = useState(4)

    const checkBidShopTheme = document.body.className == 'liquidationTwo bidShop'
    const isWizardTheme = global.storeConfigration?.bodyClass?.value == 'wizardTheme'

    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    const bodyClass = document.body.classList[1] == 'primeBids'
    const [auctionSearch, setAuctionSearch] = useState({
        page: 1,
        sh_limit: '10',
        orderby: '9',
        searchbar: '',
        auc_type: '2',
        type: '',
        auction_io: 1,
        auction_only: 1,
        no_pagination: 1,
        retail: 1,
        pallet: 1,
        filter_from_first: 0,
        filter_from_second: 0,
        auction_state:
            productLocalState.globalLocationFilter == 1
                ? []
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                : [productLocalState.globalLocation],
        auction_city:
            productLocalState.globalLocationFilter == 1
                ? [productLocalState.globalLocation]
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                : [],
        lot_images: 1,
    })

    const [searchbar] = useState(new URLSearchParams(window.location.search.substring(1)).get('q'))
    const [catg] = useState(new URLSearchParams(window.location.search.substring(1)).get('cat'))
    const params = new URLSearchParams(window.location.search.substring(1))
    const getWhere = (type, keys) => {
        let where = ' p.market_status="open" and p.qty > 0'

        if (type === 'location') {
            where += keys
        }
        return where
    }
    const formik = useFormik({
        initialValues: {
            sh_limit: sessionStorage.getItem('sh_limit'),
            page: 1,
            orderby: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '15' : '',
            location: [],
            sortType:
                global?.storeConfigration?.liquidation_filter_update?.value == 1 ? 2 : undefined,
            state: [],
            city: [],
            auction_city:
                productLocalState.globalLocationFilter == 1
                    ? [productLocalState.globalLocation]
                    : productLocalState.globalLocationFilter == 2
                    ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                    : [],
            category: catg ? [catg] : [],
            contenthead5: [],
            subcategory: [],
            condition: [],
            storedate: [],
            enddate: null,
            fromprice: 0,
            toprice: 0,
            totalpage: 5,
            lotof: '',
            searchbar: searchbar ? searchbar : '',
            miles: params.get('m') ? params.get('m') : '',
            from: '',
            auctionId: '',
            closed_auction_list: 0,
            view_type: params.get('view') ? params.get('view') : 0,
            auction_io: 1,
            conditionunique: [],
            lotsize: ['1'],
            auction_state:
                productLocalState.globalLocationFilter == 1
                    ? []
                    : productLocalState.globalLocationFilter == 2
                    ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                    : [productLocalState.globalLocation],
            orderby2: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '' : '6',
            need_bid_increment: 1,
        },
    })
    const wizPayload = {
        orderby: '02',
        closed_auction_list: 0,
        perlimit: 30,
        no_pagination: 0,
        page: 1,
        nobids: 0,
        latestbid: 1,
        latestbid_user: 1,
        lot_images: 0,
        userid: user?.id,
        getbidding: 0,
        need_bid_increment: 1,
        customwhere: params.get('q') ? getWhere('search', params.get('q')) : getWhere('search', ''),
        joins: ` inner join auctionlot as a on a.id=p.lotof `,
        location: [],
        toprice: 0,
        from: 'activeHome',
        from_id: 1,
        auction_io: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        size: [],
        get_city_state: 1,
        dont_show: global?.storeConfigration?.donot_show_categories?.value
            ? global.storeConfigration?.donot_show_categories?.value?.split(',')
            : [],
        site_id: global?.storeDetails?.site_id,
        page: 1,
        joinsdata: `a.state as auction_state, a.city as auction_city,a.country as auction_country,a.address as auction_address,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
            user?.id
                ? `,(select IFNULL(w.id,0) from watchlists as w where w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0) as watchlisted,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                : ''
        }`,
    }
    const primePayload = {
        auc_type: '2',
        page: 1,
        orderby: global?.storeConfigration?.home_pag_liq_2_changes?.value
            ? '16'
            : global?.storeConfigration?.home_page_liq_2_sorting?.value
            ? global?.storeConfigration?.home_page_liq_2_sorting?.value
            : '2',
        lotof: '',
        sh_limit: 30,
        market_status: 'open',
        auction_io: 1,
        from: global?.storeConfigration?.home_pag_liq_2_changes?.value
            ? 'auction_only'
            : global.storeConfigration?.liq_home_page_changes?.value == 1
            ? undefined
            : 'auction_only',
        auction_state:
            productLocalState.globalLocationFilter == 1
                ? []
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                : [productLocalState.globalLocation],
        auction_city:
            productLocalState.globalLocationFilter == 1
                ? [productLocalState.globalLocation]
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                : [],
        type: 'active',
        need_bid_increment: 1,
        auction_location: 1,
        viewers: 1,
        watchers: 1,
    }
    const [subLotSearch, setSubLotSearch] = useState(isWizardTheme ? wizPayload : primePayload)

    const [buynowSearch, setBuynowSearch] = useState({
        sh_limit: 16,
        from: 'buynow',
        page: 1,
        orderby: '',
        auction_io: 1,
        auction_state:
            productLocalState.globalLocationFilter == 1
                ? []
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                : [productLocalState.globalLocation],
        auction_city:
            productLocalState.globalLocationFilter == 1
                ? [productLocalState.globalLocation]
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                : [],
        viewers: 1,
        watchers: 1,
    })

    const filteredAuctions = viewAuction?.filter(
        (filterData) => filterData?.market_status === 'open',
    )
    // useEffect(() => {
    //     if (value === 0 || value === 1) {
    //         setSubLotSearch({ ...subLotSearch, type: 'active', auc_type: '2' })
    //     }
    //     if (value === 2) {
    //         setBuynowSearch({ ...buynowSearch, type: 'active' })
    //     }
    // }, [value])

    useEffect(() => {
        if (
            document.body.className == 'liquidationTwo wizardTheme' &&
            global?.storeDetails?.site_id
        ) {
            getAllTimings({
                site_id: global?.storeDetails?.site_id,
                random_id: '',
                id: '',
            })
        }
    }, [global?.storeDetails?.site_id, document.body.className])

    useEffect(() => {
        if (
            all_timings.all_locations.length > 0 &&
            all_timings.all_locations[0].range_key.length > 0
        ) {
            setAllLocations(all_timings.all_locations.map((location) => location.range_key[0]))
        }
    }, [all_timings.all_locations])

    useEffect(() => {
        if (search_allproducts.from === 'activeHome') {
            if (search_allproducts.results.length > 0) {
                search_allproducts.results.map((data) => {
                    if (data?.extra_fields?.includes('}')) {
                        let parse = JSON.parse(data.extra_fields)
                        Object.keys(parse).map((val) => {
                            data[val] = parse[val]
                        })
                    }
                })

                setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
            } else {
                setViewProduct([])
            }
            setLoading(false)
            setTotalItem(search_allproducts.total_pagecnt)
            clearTimeout(sessionTimeOutRef.current)
            clearResponse_search_details()
        } else if (search_allproducts.from === 'galleryPage') {
            if (search_allproducts.results.length > 0) {
                search_allproducts.results.map((data) => {
                    if (data?.extra_fields?.includes('}')) {
                        let parse = JSON.parse(data.extra_fields)
                        Object.keys(parse).map((val) => {
                            data[val] = parse[val]
                        })
                    }
                })
                setBuyNowProduct(
                    search_allproducts.results.length ? search_allproducts.results : [],
                )
            } else {
                setBuyNowProduct([])
            }
            // setLoading(false)
            setTotalItem(search_allproducts.total_pagecnt)
            clearResponse_search_details()
        }
    }, [search_allproducts])

    useEffect(() => {
        setLoading(true)
        if (tabValue === 2) {
            getAllSearchProducts(buynowSearch, 'galleryPage')
        }
    }, [buynowSearch])

    useEffect(() => {
        setLoading(true)
        if (isWizardTheme) {
            getAllSearchItems(
                {
                    ...subLotSearch,
                    joinsdata: `a.state as auction_state, a.city as auction_city,a.country as auction_country,a.address as auction_address,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                        user?.id
                            ? `,(select IFNULL(w.id,0) from watchlists as w where w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0) as watchlisted,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                            : ''
                    }`,
                },
                'activeHome',
            )
        } else {
            getAllSearchProducts(subLotSearch, 'activeHome')
        }
        sessionTimeOutRef.current = setTimeout(() => {
            if (!window.location.pathname.includes('/search')) {
                if (isWizardTheme) {
                    getAllSearchItems(
                        {
                            ...subLotSearch,
                            joinsdata: `a.state as auction_state, a.city as auction_city,a.country as auction_country,a.address as auction_address,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                                user?.id
                                    ? `,(select IFNULL(w.id,0) from watchlists as w where w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0) as watchlisted,(select count(f.id) as cbidnot from bids as f where f.project_id = p.id and f.user_id = ${user?.id} and f.declined=0) as cbidnot`
                                    : ''
                            }`,
                        },
                        'activeHome',
                    )
                } else {
                    getAllSearchProducts(subLotSearch, 'activeHome')
                }
            }
        }, 8000)
    }, [subLotSearch, isAuthenticated, user?.id])
    const [viewBuyNow, setBuyNow] = useState([])

    useEffect(() => {
        if (tabValue == 1) {
            setLoading(true)
            getAllSearchProducts(
                {
                    ...buynowSearch,
                    state: formik.values.state,
                    fromprice: formik.values.fromprice,
                    toprice: formik.values.toprice,
                },
                'buynowSearch',
            )
        }
    }, [buynowSearch, isAuthenticated, formik.values, tabValue])

    useEffect(() => {
        if (search_allproducts.from === 'buynowSearch') {
            setBuyNow(search_allproducts.results.length ? search_allproducts.results : [])
            setLoading(false)
            // setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
        }
    }, [search_allproducts])
    useEffect(() => {
        if (productLocalState.globalLocationFilter == 1) {
            if (subLotSearch.auction_city != productLocalState.globalLocation) {
                setSubLotSearch({
                    ...subLotSearch,
                    auction_city: [productLocalState.globalLocation],
                })
                setBuynowSearch({
                    ...buynowSearch,
                    auction_city: [productLocalState.globalLocation],
                })
                setAuctionSearch({
                    ...auctionSearch,
                    auction_city: [productLocalState.globalLocation],
                })
            }
        } else if (productLocalState.globalLocationFilter == 2) {
            let city = productLocalState.globalLocation?.split(',')?.[0]?.trim()
            let state = productLocalState.globalLocation?.split(',')?.[1]?.trim()
            if (subLotSearch.auction_city != city || subLotSearch.auction_state != state) {
                setSubLotSearch({
                    ...subLotSearch,
                    auction_city: city,
                    auction_state: state,
                })
                setBuynowSearch({
                    ...buynowSearch,
                    auction_city: city,
                    auction_state: state,
                })
                setAuctionSearch({
                    ...auctionSearch,
                    auction_city: city,
                    auction_state: state,
                })
            }
        } else {
            if (subLotSearch.auction_state != productLocalState.globalLocation) {
                setSubLotSearch({
                    ...subLotSearch,
                    auction_state: [productLocalState.globalLocation],
                })
                setBuynowSearch({
                    ...buynowSearch,
                    auction_state: [productLocalState.globalLocation],
                })
                setAuctionSearch({
                    ...auctionSearch,
                    auction_state: [productLocalState.globalLocation],
                })
            }
        }
    }, [productLocalState.globalLocation])
    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
    }
    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        socket.on('buyer_assurance', (data) => {
            handler(data, 'buyer_assurance')
        })

        socket.on('watchlist', (data) => {
            handler(data, 'watchlist')
        })

        socketAuction.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socketAuction.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        socketAuction.on('watchlist', (data) => {
            handler(data, 'watchlist')
        })

        socket.on('product_view_count', (data) => {
            handler(data, 'product_view_count')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('buyer_assurance', (data) => {
                handler(data, 'buyer_assurance')
            })

            socket.off('watchlist', (data) => {
                handler(data, 'watchlist')
            })

            socketAuction.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socketAuction.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })

            socketAuction.off('watchlist', (data) => {
                handler(data, 'watchlist')
            })

            socket.off('product_view_count', (data) => {
                handler(data, 'product_view_count')
            })
        }
    }, [])

    useEffect(() => {
        setViewProduct([])
        setBuyNowProduct([])
        return () => {
            setViewProduct([])
            setBuyNowProduct([])
        }
    }, [])

    useEffect(() => {
        setFilterValues(
            global?.allCategories
                ?.filter((val) => val.level === 0)
                ?.sort((a, b) => a.description.localeCompare(b.description)),
        )
    }, [global.allCategories])

    const handleClose = () => setSelectedProduct(null)

    const handleClick = async (id) => {
        setSelectedProduct(id)
    }

    const handleWizardClick = async (id) => {
        handleRedirectInternal(history, 'search?auctionId=' + id)
    }

    const [state, setState] = React.useState({
        bottom: false,
    })

    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }

    useEffect(() => {
        getAllSearchAuctions(auctionSearch, 'home_page')
    }, [auctionSearch])

    useEffect(() => {
        if (search_allauctions.from == 'home_page') {
            setViewAuction(search_allauctions?.results?.length ? search_allauctions?.results : [])
        } else if (!checkBidShopTheme && !isWizardTheme && viewAuction.length == 0) {
            setViewAuction(search_allauctions?.results?.length ? search_allauctions?.results : [])
        }
    }, [search_allauctions])

    useEffect(() => {
        const updateSlides = () => {
            const width = window.innerWidth
            const cols = Math.max(1, Math.floor(width / 300))
            setSlidesToShow(cols)
        }

        updateSlides()
        window.addEventListener('resize', updateSlides)
        return () => window.removeEventListener('resize', updateSlides)
    }, [])

    const subscribe = () => {
        if (inpData) {
            if (!/\S+@\S+\.\S+/.test(inpData)) {
                return setAlert('Invalid email address', 'error')
            }

            const data = {
                EMAIL: inpData,
            }

            jsonp(
                `//${global.storeConfigration?.subscribe_code.value}${queryString.stringify(data)}`,
                { param: 'c' },
                (err, data) => {
                    //console.log('display', data.result)
                    if (err) {
                        return false
                    }
                    if (data.result === 'success') {
                        setinpData('')
                        return setAlert(data.msg, 'success')
                    }
                    if (data.result === 'error') {
                        return setAlert(data.msg, 'warning')
                    }
                },
            )
        }
        setinpData('')
    }

    const NextArrow = (props) => {
        const { onClick } = props
        return (
            <Button className="custom-arrow next" onClick={onClick}>
                <span className="material-icons-outlined">arrow_forward_ios</span>
            </Button>
        )
    }

    const PrevArrow = (props) => {
        const { onClick } = props
        return (
            <Button className="custom-arrow prev" onClick={onClick}>
                <span className="material-icons-outlined">arrow_back_ios</span>
            </Button>
        )
    }

    const settings = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 10000,
        cssEase: 'linear',
    }

    const settingsWizard = {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 500,
        slidesToScroll: 4,
        slidesToShow: slidesToShow,
        variableWidth: false,
        adaptiveHeight: false,
        swipeToSlide: true,
        touchMove: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }

    const settingsEmurs = {
        dots: false,
        fade: false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        fade: true,
        autoplaySpeed: 10000,
        cssEase: 'linear',
    }
    const categoriesSettings = {
        dots: false,
        fade: false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,

        autoplay: true,
        speed: 2000,
        autoplaySpeed: 6000,
        cssEase: 'linear',
    }
    const checkThemeClassName = document.body.className == 'liquidationTwo primeBids'
    const checkEmursTheme = document.body.className == 'liquidationTwo emursMck'
    const LiquidityProject = document.body.className == 'liquidationTwo liquidity'

    const checkBeachThemeClassName = document.body.className == 'liquidationTwo beachLiquidation'
    const checkMediaWithPrimeBidTheme =
        window.matchMedia('(max-width:768px)').matches && checkThemeClassName
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    useEffect(() => {
        if (checkEmursTheme) {
            setLocalState((prevState) => ({
                ...prevState,
                globalLocation: 'New York',
                globalLocations: ['New York'],
                globalLocationFilter: 2,
            }))
            localStorage.setItem('globalLocation', JSON.stringify('New York'))
        }
        if (localStorage.getItem('globalLocation') == 'California' || checkEmursTheme) {
            localStorage.setItem('globalLocation', 'New York')
        }
    }, [search_allproducts, subLotSearch])

    const imgPath = [item1, item2, item3, item4]

    const calculateCardWidth = () => {
        const firstCard = containerRef.current?.children[0]
        if (firstCard) {
            setCardWidth(firstCard.offsetWidth)
        }
    }

    useEffect(() => {
        calculateCardWidth()
        window.addEventListener('resize', calculateCardWidth)

        return () => {
            window.removeEventListener('resize', calculateCardWidth)
        }
    }, [])
    const mobileBanners = useMemo(
        () =>
            global?.multipleMobileBannersFields?.map((b) => ({
                ...b,
                fieldsParsed: b.fields ? JSON.parse(b.fields) : {},
            })) || [],
        [global?.multipleMobileBannersFields],
    )
    const isSmallMobile = useMediaQuery({
        query: '(max-width: 530px)',
    })
    return (
        <Layout props={props}>
            {isPrimeBids ? <SEOTAG page="Home" /> : null}
            <div className="home">
                <>
                    {checkEmursTheme ? (
                        <div className="customContainer seperator bannerContainer">
                            <div className="siteBanner multiple">
                                <Slider {...settingsEmurs}>
                                    {global.multipleBannersFields?.map((data, index) => (
                                        <>
                                            <LazyLoadImage
                                                src={
                                                    process.env.REACT_APP_AUCTION_IMAGE_URL +
                                                    '/' +
                                                    data?.image_name
                                                }
                                                alt={`${data?.image_name} banner`}
                                                effect="blur"
                                                height="225"
                                                width="100%"
                                            />
                                            <div className="bannerContent">
                                                <h2 className="">
                                                    {
                                                        JSON.parse(data.fields ? data.fields : '{}')
                                                            .title
                                                    }
                                                </h2>

                                                {checkEmursTheme && (
                                                    <>
                                                        <h2>{`The McKittrick Hotel`}</h2>
                                                        <h3>{`Scenery & Props Auction`}</h3>
                                                        {/* <h2>DRAMA IS OVER</h2> 
                                                        <h3>
                                                            LETS BID NOW{' '}
                                                            {/* <span>{subLotSearch.auction_city}</span> 
                                                        </h3> */}
                                                        <div className="text-center">
                                                            {!isAuthenticated ? (
                                                                <PrimaryButton
                                                                    label={
                                                                        isAuthenticated
                                                                            ? JSON.parse(
                                                                                  data.fields
                                                                                      ? data.fields
                                                                                      : '{}',
                                                                              ).btn_text
                                                                            : 'SIGNUP'
                                                                    }
                                                                    type="button"
                                                                    onClick={() =>
                                                                        !isAuthenticated
                                                                            ? handleRedirectInternal(
                                                                                  history,
                                                                                  'sign-up',
                                                                              )
                                                                            : (window.location.href =
                                                                                  JSON.parse(
                                                                                      global
                                                                                          .multipleBannersFields[
                                                                                          index
                                                                                      ].fields
                                                                                          ? global
                                                                                                .multipleBannersFields[
                                                                                                index
                                                                                            ].fields
                                                                                          : '{}',
                                                                                  ).btn_link)
                                                                    }
                                                                />
                                                            ) : null}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    ) : null}
                    {!isWizardTheme ? (
                        checkEmursTheme ? null : (
                            <div className="customContainer bannerContainer">
                                {isSmallMobile ? (
                                    <>
                                        <div className="siteBanner multiple">
                                            <Slider {...settings}>
                                                {mobileBanners?.map((img, index) => {
                                                    const imgsrc = `${process.env.REACT_APP_AUCTION_IMAGE_URL}/${img?.image_name}`
                                                    return (
                                                        <div className="banner-item" key={index}>
                                                            <LazyLoadImage
                                                                src={imgsrc}
                                                                alt="Banner"
                                                                width={500}
                                                                height={170}
                                                                effect="blur"
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </Slider>
                                        </div>
                                    </>
                                ) : global.multipleBannersFields.length ? (
                                    <div className="siteBanner multiple">
                                        {
                                            <Slider {...settings}>
                                                {global.multipleBannersFields?.map(
                                                    (data, index) => (
                                                        <>
                                                            <div
                                                                style={{
                                                                    width: '100%',
                                                                    height: checkBidShopTheme
                                                                        ? '500px'
                                                                        : '225px',

                                                                    backgroundColor:
                                                                        checkBidShopTheme
                                                                            ? '#000'
                                                                            : 'initial',
                                                                }}
                                                            >
                                                                <LazyLoadImage
                                                                    src={
                                                                        process.env
                                                                            .REACT_APP_AUCTION_IMAGE_URL +
                                                                        '/' +
                                                                        data?.image_name
                                                                    }
                                                                    alt={`${data?.image_name} banner`}
                                                                    effect="blur"
                                                                    height={`${
                                                                        checkBidShopTheme
                                                                            ? '500'
                                                                            : '225'
                                                                    }`}
                                                                    width="100%"
                                                                    srcSet={`${
                                                                        process.env
                                                                            .REACT_APP_AUCTION_IMAGE_URL +
                                                                        '/' +
                                                                        `${data?.image_name} 400w`
                                                                    }, ${
                                                                        process.env
                                                                            .REACT_APP_AUCTION_IMAGE_URL +
                                                                        '/' +
                                                                        `${data?.image_name} 800w`
                                                                    } `}
                                                                    sizes="(max-width: 600px) 400px, 800px"
                                                                    placeholderSrc="/assets/svg/imageLoading.svg"
                                                                />
                                                            </div>
                                                            {/* <img
                                                                src={
                                                                    process.env
                                                                        .REACT_APP_AUCTION_IMAGE_URL +
                                                                    '/' +
                                                                    data?.image_name
                                                                }
                                                                width={500}
                                                                height={150}
                                                            /> */}
                                                            <div className="bannerContent">
                                                                <h2 className="">
                                                                    {
                                                                        JSON.parse(
                                                                            data.fields
                                                                                ? data.fields
                                                                                : '{}',
                                                                        ).title
                                                                    }
                                                                </h2>

                                                                {checkThemeClassName && (
                                                                    <>
                                                                        {/* <h2 className="">
                                                                            {
                                                                                JSON.parse(
                                                                                    data.fields
                                                                                        ? data.fields
                                                                                        : '{}',
                                                                                ).description
                                                                            }
                                                                        </h2> */}
                                                                        <h3>
                                                                            Bid, Buy, and Enjoy!
                                                                        </h3>
                                                                        <h2>
                                                                            Shop & <br />
                                                                            Save in{' '}
                                                                            <span>
                                                                                {
                                                                                    subLotSearch.auction_city
                                                                                }
                                                                            </span>
                                                                            .
                                                                        </h2>

                                                                        <PrimaryButton
                                                                            label={
                                                                                isAuthenticated
                                                                                    ? JSON.parse(
                                                                                          data.fields
                                                                                              ? data.fields
                                                                                              : '{}',
                                                                                      ).btn_text
                                                                                    : 'Create your free account'
                                                                            }
                                                                            type="button"
                                                                            onClick={() =>
                                                                                !isAuthenticated
                                                                                    ? handleRedirectInternal(
                                                                                          history,
                                                                                          'sign-up',
                                                                                      )
                                                                                    : (window.location.href =
                                                                                          JSON.parse(
                                                                                              global
                                                                                                  .multipleBannersFields[
                                                                                                  index
                                                                                              ]
                                                                                                  .fields
                                                                                                  ? global
                                                                                                        .multipleBannersFields[
                                                                                                        index
                                                                                                    ]
                                                                                                        .fields
                                                                                                  : '{}',
                                                                                          ).btn_link)
                                                                            }
                                                                        />
                                                                    </>
                                                                )}
                                                            </div>
                                                        </>
                                                    ),
                                                )}
                                            </Slider>
                                        }
                                    </div>
                                ) : (
                                    <div className="siteBanner">
                                        <LazyLoadImage
                                            src={global?.storeDetails?.bannerValue}
                                            alt={`${global?.storeDetails?.name} banner`}
                                            effect="blur"
                                            height="100%"
                                            width="100%"
                                        />
                                        <div className="bannerContent">
                                            <h2>{global?.storeDetails?.description}</h2>
                                        </div>
                                    </div>
                                )}
                                {checkThemeClassName || checkEmursTheme || checkBidShopTheme ? (
                                    ''
                                ) : (
                                    <div>
                                        <h3 className="todayDealsTit">Today&apos;s Deals</h3>
                                        <div className="PmCategoryBase-root">
                                            {filterValues?.map((data, index) => (
                                                <div
                                                    className="PmCategoryList-root"
                                                    key={index}
                                                    onClick={() =>
                                                        handleRedirectInternal(
                                                            history,
                                                            'search?q=&z=&m=&view=0&cat=' + data.id,
                                                        )
                                                    }
                                                >
                                                    <picture className="PmCategoryImage-root">
                                                        <LazyLoadImage
                                                            src={
                                                                data.image != 'noimg'
                                                                    ? process.env
                                                                          .REACT_APP_PRODUCT_IMAGE_URL +
                                                                      data.image
                                                                    : process.env
                                                                          .REACT_APP_AUCTION_IMAGE_URL +
                                                                      global?.storeDetails?.logo
                                                            }
                                                            alt={`${data?.description} banner`}
                                                            effect="blur"
                                                            height="100%"
                                                            width="100%"
                                                            data-src="image.jpg"
                                                            className="PmCategoryImage lazy"
                                                        />
                                                        {/* <img
                                                            className="PmCategoryImage lazy"
                                                            src={
                                                                data.image != 'noimg'
                                                                    ? process.env
                                                                          .REACT_APP_PRODUCT_IMAGE_URL +
                                                                      data.image
                                                                    : process.env
                                                                          .REACT_APP_AUCTION_IMAGE_URL +
                                                                      global?.storeDetails?.logo
                                                            }
                                                            data-src="image.jpg"
                                                            alt={data.description}
                                                        /> */}
                                                    </picture>
                                                    <h4 className="PmCategoryTitle m-0">
                                                        {data.description}
                                                    </h4>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    ) : (
                        <div className="customContainer bannerContainer">
                            <div className={`siteBanner ${isAuthenticated ? 'login' : ''}`}>
                                {isAuthenticated ? (
                                    <div className="wizardSi">
                                        <div className="bannerContents">
                                            <div className="bannerContent d-flex align-items-center justify-content-around mb-2">
                                                <div className="bannetContentWrp">
                                                    <h2>{global?.storeDetails?.description}</h2>
                                                    <Button className="lgSgnBtn">
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/dashboard/favorites"
                                                            className="signInButton"
                                                        >
                                                            Your Favorites{' '}
                                                        </NavLink>

                                                        <span className="material-icons">
                                                            verified
                                                        </span>
                                                    </Button>
                                                </div>
                                            </div>
                                            <NavLink
                                                to="/how_it_works"
                                                style={{
                                                    color: 'unset',
                                                    textDecoration: 'underline',
                                                }}
                                            >
                                                <div className="howItCard text-center text-white">
                                                    <h2 className="mb-3">How it works ?</h2>
                                                    <div className="hiw-container">
                                                        <div className="hiw d-flex align-items-center">
                                                            <img src="/assets/images/wizardAuctions/BidImg.svg" />
                                                            <div>
                                                                <h3>BID</h3>
                                                                <p>
                                                                    Free to sign up, simply browse,
                                                                    bid, and let the magic unfold.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="hiw d-flex align-items-center">
                                                            <img src="/assets/images/wizardAuctions/WinImg.svg" />
                                                            <div>
                                                                <h3>WIN</h3>
                                                                <p>
                                                                    Saving has never felt so
                                                                    enchanting.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="hiw d-flex align-items-center">
                                                            <img src="/assets/images/wizardAuctions/PickUpImg.png" />
                                                            <div>
                                                                <h3>PICK UP</h3>
                                                                <p>
                                                                    Collect your treasures within 5
                                                                    days of the auction closing.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </NavLink>
                                        </div>
                                        <div className="widthChange" style={{ width: '50%' }}>
                                            <h2 className="text-center">Ending Soon</h2>
                                            <div className="wizardCards">
                                                {viewAuction.length ? (
                                                    <>
                                                        {viewAuction
                                                            ?.filter(
                                                                (ele) =>
                                                                    new Date(ele.date_closed) >=
                                                                    now,
                                                            )
                                                            ?.sort(
                                                                (a, b) =>
                                                                    new Date(a.date_closed) -
                                                                    new Date(b.date_closed),
                                                            )
                                                            ?.slice(0, 1)
                                                            .map((data, index) => (
                                                                <MultisellerListCard
                                                                    data={data}
                                                                    key={index}
                                                                    details={`search?auctionId=${data.id}`}
                                                                    card_theme="liquidationTwo"
                                                                    handleLotClick={
                                                                        handleWizardClick
                                                                    }
                                                                />
                                                            ))}
                                                    </>
                                                ) : null}

                                                {viewProduct
                                                    ?.filter(
                                                        (ele) =>
                                                            ele.auction === 1 &&
                                                            new Date(ele.date_closed) >= now,
                                                    )
                                                    ?.sort(
                                                        (a, b) =>
                                                            new Date(a.date_closed) -
                                                            new Date(b.date_closed),
                                                    )
                                                    ?.slice(0, 1)
                                                    ?.map((data, index) => {
                                                        return (
                                                            <>
                                                                {!checkMediaWithPrimeBidTheme ? (
                                                                    <div className="homeGridCard">
                                                                        <GridProduct
                                                                            data={data}
                                                                            className={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            key={index}
                                                                            type={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            selectedProduct={
                                                                                selectedProduct
                                                                            }
                                                                            link={`/gallery/product-view/${data.id}`}
                                                                            handleClick={
                                                                                handleClick
                                                                            }
                                                                            timerTheme={
                                                                                isPrimeBids
                                                                                    ? 'gFThemeTimer'
                                                                                    : ''
                                                                            }
                                                                            sliderTheme="multiseller"
                                                                            cardTheme="liquidationTwo"
                                                                            bidBtnLabel="Bid Now"
                                                                            showCondition={false}
                                                                            showLocation={true}
                                                                            timerIcon={true}
                                                                            bidStatus={true}
                                                                            setViewProduct={
                                                                                setViewProduct
                                                                            }
                                                                            viewProduct={
                                                                                viewProduct
                                                                            }
                                                                            showDateNumber={2}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div className="lotResults mb-4 liquidationBuyCard">
                                                                        <GridProduct
                                                                            data={data}
                                                                            className={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            key={index}
                                                                            type={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            selectedProduct={
                                                                                selectedProduct
                                                                            }
                                                                            link={`/gallery/product-view/${data.id}`}
                                                                            handleClick={
                                                                                handleClick
                                                                            }
                                                                            timerTheme={
                                                                                isPrimeBids
                                                                                    ? 'gFThemeTimer'
                                                                                    : ''
                                                                            }
                                                                            sliderTheme="multiseller"
                                                                            cardTheme="liquidationTwo"
                                                                            bidBtnLabel="Place Bid"
                                                                            showCondition={false}
                                                                            showLocation={true}
                                                                            timerIcon={true}
                                                                            bidStatus={true}
                                                                            setViewProduct={
                                                                                setViewProduct
                                                                            }
                                                                            viewProduct={
                                                                                viewProduct
                                                                            }
                                                                            showDateNumber={2}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </>
                                                        )
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="bannerContent d-flex align-items-center justify-content-around mb-2">
                                            <div>
                                                <h2>{global?.storeDetails?.description}</h2>
                                                <Button className="lgSgnBtn">
                                                    <NavLink
                                                        activeClassName="active"
                                                        to="/login"
                                                        className="signInButton"
                                                    >
                                                        Join Now
                                                    </NavLink>
                                                </Button>
                                            </div>
                                            <LazyLoadImage
                                                src={global?.storeDetails?.bannerValue}
                                                alt={`${global?.storeDetails?.name} banner`}
                                                effect="blur"
                                                height="100%"
                                                width="100%"
                                            />
                                        </div>
                                        <div className="wizardCards wizardUnLogCards">
                                            <div>
                                                <h2 className="text-center text-white">
                                                    Ending Soon
                                                </h2>
                                                <div className="CardsMain">
                                                    {viewAuction.length ? (
                                                        <>
                                                            {viewAuction
                                                                ?.filter(
                                                                    (ele) =>
                                                                        new Date(ele.date_closed) >=
                                                                        now,
                                                                )
                                                                ?.sort(
                                                                    (a, b) =>
                                                                        new Date(a.date_closed) -
                                                                        new Date(b.date_closed),
                                                                )
                                                                ?.slice(0, 1)
                                                                .map((data, index) => (
                                                                    <MultisellerListCard
                                                                        data={data}
                                                                        key={index}
                                                                        details={`search?auctionId=${data.id}`}
                                                                        card_theme="liquidationTwo"
                                                                        handleLotClick={
                                                                            handleWizardClick
                                                                        }
                                                                    />
                                                                ))}
                                                        </>
                                                    ) : null}

                                                    {viewProduct
                                                        ?.filter(
                                                            (ele) =>
                                                                ele.auction === 1 &&
                                                                new Date(ele.date_closed) >= now,
                                                        )
                                                        ?.sort(
                                                            (a, b) =>
                                                                new Date(a.date_closed) -
                                                                new Date(b.date_closed),
                                                        )
                                                        ?.slice(0, 1)
                                                        ?.map((data, index) => {
                                                            return (
                                                                <>
                                                                    {!checkMediaWithPrimeBidTheme ? (
                                                                        <div className="homeGridCard">
                                                                            <GridProduct
                                                                                data={data}
                                                                                className={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                key={index}
                                                                                type={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                selectedProduct={
                                                                                    selectedProduct
                                                                                }
                                                                                link={`/gallery/product-view/${data.id}`}
                                                                                handleClick={
                                                                                    handleClick
                                                                                }
                                                                                timerTheme={
                                                                                    isPrimeBids
                                                                                        ? 'gFThemeTimer'
                                                                                        : ''
                                                                                }
                                                                                sliderTheme="multiseller"
                                                                                cardTheme="liquidationTwo"
                                                                                bidBtnLabel="Bid Now"
                                                                                showCondition={
                                                                                    false
                                                                                }
                                                                                showLocation={true}
                                                                                timerIcon={true}
                                                                                bidStatus={true}
                                                                                setViewProduct={
                                                                                    setViewProduct
                                                                                }
                                                                                viewProduct={
                                                                                    viewProduct
                                                                                }
                                                                                showDateNumber={2}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="lotResults mb-4 liquidationBuyCard">
                                                                            <GridProduct
                                                                                data={data}
                                                                                className={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                key={index}
                                                                                type={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                selectedProduct={
                                                                                    selectedProduct
                                                                                }
                                                                                link={`/gallery/product-view/${data.id}`}
                                                                                handleClick={
                                                                                    handleClick
                                                                                }
                                                                                timerTheme={
                                                                                    isPrimeBids
                                                                                        ? 'gFThemeTimer'
                                                                                        : ''
                                                                                }
                                                                                sliderTheme="multiseller"
                                                                                cardTheme="liquidationTwo"
                                                                                bidBtnLabel="Place Bid"
                                                                                showCondition={
                                                                                    false
                                                                                }
                                                                                showLocation={true}
                                                                                timerIcon={true}
                                                                                bidStatus={true}
                                                                                setViewProduct={
                                                                                    setViewProduct
                                                                                }
                                                                                viewProduct={
                                                                                    viewProduct
                                                                                }
                                                                                showDateNumber={2}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )
                                                        })}
                                                </div>
                                            </div>
                                            <div>
                                                <h2 style={{ height: '38.39px' }}></h2>
                                                <div className="CardsMain">
                                                    <NavLink to="/how_it_works">
                                                        <div className="howItCard text-center">
                                                            <h2 className="mb-3">How it works ?</h2>
                                                            <div className="d-flex align-items-center mb-1">
                                                                <img src="/assets/images/wizardAuctions/BidImg.svg" />
                                                                <div>
                                                                    <h3>BID</h3>
                                                                    <p>
                                                                        Free to sign up, simply
                                                                        browse, bid, and let the
                                                                        magic unfold.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center mb-1 flex-row-reverse">
                                                                <img src="/assets/images/wizardAuctions/WinImg.svg" />
                                                                <div>
                                                                    <h3>WIN</h3>
                                                                    <p>
                                                                        Saving has never felt so
                                                                        enchanting.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <img src="/assets/images/wizardAuctions/PickUpImg.png" />
                                                                <div>
                                                                    <h3>PICK UP</h3>
                                                                    <p>
                                                                        Collect your treasures
                                                                        within 5 days of the auction
                                                                        closing.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </NavLink>
                                                    <div className="howItCard justify-content-start text-center">
                                                        <img
                                                            className="wizardImg"
                                                            src="/assets/images/wizardAuctions/WizardImg.png"
                                                        />
                                                        <p className="quest">
                                                            Your quest to Magical Savings Begins
                                                            Here!
                                                        </p>
                                                        <Button
                                                            className="lgSgnBtn mt-2"
                                                            style={{
                                                                maxWidth: '165px',
                                                                margin: 'auto',
                                                            }}
                                                        >
                                                            <NavLink
                                                                activeClassName="active"
                                                                to="/login"
                                                                className="signInButton"
                                                            >
                                                                Sign Up
                                                            </NavLink>
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                    {checkThemeClassName || checkEmursTheme || checkBidShopTheme ? (
                        ''
                    ) : (
                        <div className="customContainer">
                            <h3 className="todayDealsTit ">Category</h3>
                            <div className="PmCategoryBase-root categories position-relative">
                                {filterValues
                                    ?.filter((filterItem) =>
                                        global.searchCategories.some(
                                            (category) =>
                                                filterItem.description === category.description,
                                        ),
                                    )
                                    ?.map((data, index) => {
                                        const categoryToUpdate = global.searchCategories.find(
                                            (category) => category.description === data.description,
                                        )

                                        const updatedData = categoryToUpdate
                                            ? { ...data, id: categoryToUpdate.id }
                                            : data

                                        return (
                                            <div
                                                className="PmCategoryList-root"
                                                key={index}
                                                onClick={() =>
                                                    handleRedirectInternal(
                                                        history,
                                                        'search?q=&z=&m=&view=0&cat=' +
                                                            updatedData.id,
                                                    )
                                                }
                                            >
                                                <picture className="PmCategoryImage-root">
                                                    <img
                                                        className="PmCategoryImage lazy"
                                                        src={
                                                            updatedData.image != 'noimg'
                                                                ? process.env
                                                                      .REACT_APP_PRODUCT_IMAGE_URL +
                                                                  updatedData.image
                                                                : process.env
                                                                      .REACT_APP_AUCTION_IMAGE_URL +
                                                                  global?.storeDetails?.logo
                                                        }
                                                        data-src="image.jpg"
                                                        alt={updatedData.description}
                                                    />
                                                </picture>
                                                <h4 className="PmCategoryTitle m-0">
                                                    {updatedData.description}
                                                </h4>
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                    )}
                    <div className="customContainer auctionListCnt">
                        {!isWizardTheme ? (
                            <>
                                {global?.storeConfigration?.homeTrendingView?.value == 1 ? (
                                    <div className="searchHomeContainer">
                                        {global.storeConfigration?.liq_home_page_changes?.value ==
                                        1 ? (
                                            <>
                                                {viewProduct?.map((data, index) => {
                                                    if (index < 15) {
                                                        return (
                                                            <div className="homeGridCard">
                                                                <GridProduct
                                                                    data={data}
                                                                    className={
                                                                        data.auction
                                                                            ? 'auction'
                                                                            : 'buynow'
                                                                    }
                                                                    key={index}
                                                                    type={
                                                                        data.auction
                                                                            ? 'auction'
                                                                            : 'buynow'
                                                                    }
                                                                    selectedProduct={
                                                                        selectedProduct
                                                                    }
                                                                    link={`/gallery/product-view/${data.id}`}
                                                                    handleClick={handleClick}
                                                                    timerTheme={
                                                                        isPrimeBids
                                                                            ? 'gFThemeTimer'
                                                                            : ''
                                                                    }
                                                                    sliderTheme="multiseller"
                                                                    cardTheme="liquidationTwo"
                                                                    bidBtnLabel="Place Bid"
                                                                    showCondition={false}
                                                                    showLocation={true}
                                                                    timerIcon={true}
                                                                    bidStatus={true}
                                                                    setViewProduct={setViewProduct}
                                                                    viewProduct={viewProduct}
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </>
                                        ) : (
                                            <>
                                                {viewProduct
                                                    ?.filter(
                                                        (ele) =>
                                                            ele.auction == 1 && ele.buynow == 1,
                                                    )
                                                    ?.map((data, index) => {
                                                        if (index < 15) {
                                                            return (
                                                                <div
                                                                    className="homeGridCard"
                                                                    key={index}
                                                                >
                                                                    <GridProduct
                                                                        data={data}
                                                                        className={
                                                                            data.auction
                                                                                ? 'auction'
                                                                                : 'buynow'
                                                                        }
                                                                        key={index}
                                                                        type={
                                                                            data.auction
                                                                                ? 'auction'
                                                                                : 'buynow'
                                                                        }
                                                                        selectedProduct={
                                                                            selectedProduct
                                                                        }
                                                                        link={`/gallery/product-view/${data.id}`}
                                                                        handleClick={handleClick}
                                                                        timerTheme={
                                                                            isPrimeBids
                                                                                ? 'gFThemeTimer'
                                                                                : ''
                                                                        }
                                                                        sliderTheme="multiseller"
                                                                        cardTheme="liquidationTwo"
                                                                        bidBtnLabel="Bid Now"
                                                                        showCondition={false}
                                                                        showLocation={true}
                                                                        timerIcon={true}
                                                                        bidStatus={true}
                                                                        setViewProduct={
                                                                            setViewProduct
                                                                        }
                                                                        viewProduct={viewProduct}
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                            </>
                                        )}
                                    </div>
                                ) : (
                                    <div className={checkEmursTheme ? 'seperator' : null}>
                                        {(checkThemeClassName ||
                                            checkEmursTheme ||
                                            checkBidShopTheme) && (
                                            <div className="pmEllipseContainer trendingLabelContainer d-flex align-items-center py-3">
                                                {!checkBidShopTheme && (
                                                    <div className="PmEllipse">
                                                        <span className="material-icons-outlined">
                                                            trending_up
                                                        </span>
                                                    </div>
                                                )}
                                                <h3>
                                                    Trending Now in{' '}
                                                    {checkBidShopTheme
                                                        ? subLotSearch.auction_state
                                                        : subLotSearch.auction_city}
                                                </h3>
                                            </div>
                                        )}
                                        <div className="tabHeader">
                                            <Tabs value={tabValue} onChange={handleTabChange}>
                                                <Tab label="Active Lots" {...a11yProps(0)} />
                                                <Tab label="Buy Now" {...a11yProps(1)} />
                                                <div className="ml-auto">
                                                    <NavLink
                                                        activeClassName="active"
                                                        className="ctLink"
                                                        to="/search"
                                                    >
                                                        View all trending
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="31"
                                                            height="30"
                                                            viewBox="0 0 31 30"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M16.8238 8.49582C17.0816 8.23802 17.4996 8.23802 17.7574 8.49582L23.7325 14.4709C23.9903 14.7287 23.9903 15.1467 23.7325 15.4045L17.7574 21.3796C17.4996 21.6374 17.0816 21.6374 16.8238 21.3796C16.566 21.1217 16.566 20.7038 16.8238 20.4459L21.6719 15.5979H8.32806C7.96346 15.5979 7.6679 15.3023 7.6679 14.9377C7.6679 14.5731 7.96346 14.2775 8.32806 14.2775L21.6719 14.2775L16.8238 9.42943C16.566 9.17162 16.566 8.75363 16.8238 8.49582Z"
                                                                fill="#ffffff"
                                                            />
                                                        </svg>
                                                    </NavLink>{' '}
                                                </div>
                                            </Tabs>
                                        </div>
                                        {/* <div className="homeLoader">
                                            <Loaders
                                                name="product_grid_view"
                                                isLoading={true}
                                                loop={5}
                                            />
                                        </div> */}

                                        {checkThemeClassName || checkEmursTheme ? (
                                            <>
                                                <TabPanel value={tabValue} index={0}>
                                                    <div className="homeCnt">
                                                        <>
                                                            {loading ? (
                                                                <div className="homeLoader">
                                                                    <Loaders
                                                                        name="product_grid_view"
                                                                        isLoading={loading}
                                                                        loop={5}
                                                                    />
                                                                </div>
                                                            ) : viewProduct.length === 0 ? (
                                                                <NoRecordsFound />
                                                            ) : (
                                                                <div>
                                                                    <div
                                                                        className={
                                                                            'searchHomeContainer'
                                                                        }
                                                                    >
                                                                        {viewProduct
                                                                            ?.filter(
                                                                                (ele) =>
                                                                                    ele.auction ==
                                                                                    1,
                                                                            )
                                                                            ?.slice(
                                                                                0,
                                                                                checkThemeClassName
                                                                                    ? 20
                                                                                    : 30,
                                                                            )
                                                                            ?.map((data, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {!checkMediaWithPrimeBidTheme ? (
                                                                                            <div className="homeGridCard">
                                                                                                <GridProduct
                                                                                                    data={
                                                                                                        data
                                                                                                    }
                                                                                                    className={
                                                                                                        data.auction
                                                                                                            ? 'auction'
                                                                                                            : 'buynow'
                                                                                                    }
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                    type={
                                                                                                        data.auction
                                                                                                            ? 'auction'
                                                                                                            : 'buynow'
                                                                                                    }
                                                                                                    selectedProduct={
                                                                                                        selectedProduct
                                                                                                    }
                                                                                                    link={`/gallery/product-view/${data.id}`}
                                                                                                    handleClick={
                                                                                                        handleClick
                                                                                                    }
                                                                                                    timerTheme={
                                                                                                        isPrimeBids
                                                                                                            ? 'gFThemeTimer'
                                                                                                            : ''
                                                                                                    }
                                                                                                    sliderTheme="multiseller"
                                                                                                    cardTheme="liquidationTwo"
                                                                                                    bidBtnLabel="Place Bid"
                                                                                                    showCondition={
                                                                                                        false
                                                                                                    }
                                                                                                    showLocation={
                                                                                                        true
                                                                                                    }
                                                                                                    timerIcon={
                                                                                                        true
                                                                                                    }
                                                                                                    bidStatus={
                                                                                                        true
                                                                                                    }
                                                                                                    setViewProduct={
                                                                                                        setViewProduct
                                                                                                    }
                                                                                                    viewProduct={
                                                                                                        viewProduct
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div className="lotResults mb-4 liquidationBuyCard">
                                                                                                <GridProduct
                                                                                                    data={
                                                                                                        data
                                                                                                    }
                                                                                                    className={
                                                                                                        data.auction
                                                                                                            ? 'auction'
                                                                                                            : 'buynow'
                                                                                                    }
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                    type={
                                                                                                        data.auction
                                                                                                            ? 'auction'
                                                                                                            : 'buynow'
                                                                                                    }
                                                                                                    selectedProduct={
                                                                                                        selectedProduct
                                                                                                    }
                                                                                                    link={`/gallery/product-view/${data.id}`}
                                                                                                    handleClick={
                                                                                                        handleClick
                                                                                                    }
                                                                                                    timerTheme={
                                                                                                        isPrimeBids
                                                                                                            ? 'gFThemeTimer'
                                                                                                            : ''
                                                                                                    }
                                                                                                    sliderTheme="multiseller"
                                                                                                    cardTheme="liquidationTwo"
                                                                                                    bidBtnLabel="Place Bid"
                                                                                                    showCondition={
                                                                                                        false
                                                                                                    }
                                                                                                    showLocation={
                                                                                                        true
                                                                                                    }
                                                                                                    timerIcon={
                                                                                                        true
                                                                                                    }
                                                                                                    bidStatus={
                                                                                                        true
                                                                                                    }
                                                                                                    setViewProduct={
                                                                                                        setViewProduct
                                                                                                    }
                                                                                                    viewProduct={
                                                                                                        viewProduct
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                )
                                                                            })}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    </div>
                                                </TabPanel>
                                                <div className="d-flex justify-content-end pt-2">
                                                    <NavLink
                                                        activeClassName="active"
                                                        className="ctLink"
                                                        to="/search"
                                                    >
                                                        View all trending
                                                        {checkEmursTheme ? (
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="31"
                                                                height="30"
                                                                viewBox="0 0 31 30"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M16.8238 8.49582C17.0816 8.23802 17.4996 8.23802 17.7574 8.49582L23.7325 14.4709C23.9903 14.7287 23.9903 15.1467 23.7325 15.4045L17.7574 21.3796C17.4996 21.6374 17.0816 21.6374 16.8238 21.3796C16.566 21.1217 16.566 20.7038 16.8238 20.4459L21.6719 15.5979H8.32806C7.96346 15.5979 7.6679 15.3023 7.6679 14.9377C7.6679 14.5731 7.96346 14.2775 8.32806 14.2775L21.6719 14.2775L16.8238 9.42943C16.566 9.17162 16.566 8.75363 16.8238 8.49582Z"
                                                                    fill="#ffffff"
                                                                />
                                                            </svg>
                                                        ) : (
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="31"
                                                                height="30"
                                                                viewBox="0 0 31 30"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M16.8238 8.49582C17.0816 8.23802 17.4996 8.23802 17.7574 8.49582L23.7325 14.4709C23.9903 14.7287 23.9903 15.1467 23.7325 15.4045L17.7574 21.3796C17.4996 21.6374 17.0816 21.6374 16.8238 21.3796C16.566 21.1217 16.566 20.7038 16.8238 20.4459L21.6719 15.5979H8.32806C7.96346 15.5979 7.6679 15.3023 7.6679 14.9377C7.6679 14.5731 7.96346 14.2775 8.32806 14.2775L21.6719 14.2775L16.8238 9.42943C16.566 9.17162 16.566 8.75363 16.8238 8.49582Z"
                                                                    fill="#222222"
                                                                />
                                                            </svg>
                                                        )}
                                                    </NavLink>{' '}
                                                </div>
                                            </>
                                        ) : checkBidShopTheme ? (
                                            <>
                                                <TabPanel value={tabValue} index={0}>
                                                    {loading ? (
                                                        <div className="homeLoader">
                                                            <Loaders
                                                                name="product_grid_view"
                                                                isLoading={loading}
                                                                loop={5}
                                                            />
                                                        </div>
                                                    ) : viewProduct.length === 0 ? (
                                                        <NoRecordsFound />
                                                    ) : (
                                                        <div className="trendingHomeProducts">
                                                            {viewProduct
                                                                ?.filter((ele) => ele.auction == 1)
                                                                ?.map((data, index) => {
                                                                    if (index < 28) {
                                                                        return (
                                                                            <>
                                                                                <div className="homeGridCard">
                                                                                    <GridProduct
                                                                                        data={data}
                                                                                        className={
                                                                                            data.auction
                                                                                                ? 'auction'
                                                                                                : 'buynow'
                                                                                        }
                                                                                        key={index}
                                                                                        type={
                                                                                            data.auction
                                                                                                ? 'auction'
                                                                                                : 'buynow'
                                                                                        }
                                                                                        selectedProduct={
                                                                                            selectedProduct
                                                                                        }
                                                                                        link={`/gallery/product-view/${data.id}`}
                                                                                        handleClick={
                                                                                            handleClick
                                                                                        }
                                                                                        timerTheme={
                                                                                            isPrimeBids
                                                                                                ? 'gFThemeTimer'
                                                                                                : ''
                                                                                        }
                                                                                        sliderTheme="multiseller"
                                                                                        cardTheme="liquidationTwo"
                                                                                        bidBtnLabel="Place Bid"
                                                                                        fromComponent="home"
                                                                                        showCondition={
                                                                                            false
                                                                                        }
                                                                                        showLocation={
                                                                                            true
                                                                                        }
                                                                                        timerIcon={
                                                                                            true
                                                                                        }
                                                                                        bidStatus={
                                                                                            true
                                                                                        }
                                                                                        setViewProduct={
                                                                                            setViewProduct
                                                                                        }
                                                                                        viewProduct={
                                                                                            viewProduct
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }
                                                                })}
                                                        </div>
                                                    )}
                                                </TabPanel>
                                                <TabPanel value={tabValue} index={1}>
                                                    {loading ? (
                                                        <div className="homeLoader">
                                                            <Loaders
                                                                name="product_grid_view"
                                                                isLoading={loading}
                                                                loop={5}
                                                            />
                                                        </div>
                                                    ) : viewBuyNow.length === 0 ? (
                                                        <NoRecordsFound />
                                                    ) : (
                                                        <div className="trendingHomeProducts">
                                                            {viewBuyNow
                                                                ?.filter((ele) => ele.buynow == 1)
                                                                ?.map((data, index) => {
                                                                    if (index < 28) {
                                                                        return (
                                                                            <>
                                                                                <div className="homeGridCard">
                                                                                    <GridProduct
                                                                                        data={data}
                                                                                        className={
                                                                                            data.auction
                                                                                                ? 'auction'
                                                                                                : 'buynow'
                                                                                        }
                                                                                        key={index}
                                                                                        type={
                                                                                            data.auction
                                                                                                ? 'auction'
                                                                                                : 'buynow'
                                                                                        }
                                                                                        selectedProduct={
                                                                                            selectedProduct
                                                                                        }
                                                                                        link={`/gallery/product-view/${data.id}`}
                                                                                        handleClick={
                                                                                            handleClick
                                                                                        }
                                                                                        timerTheme={
                                                                                            isPrimeBids
                                                                                                ? 'gFThemeTimer'
                                                                                                : ''
                                                                                        }
                                                                                        sliderTheme="multiseller"
                                                                                        cardTheme="liquidationTwo"
                                                                                        bidBtnLabel="Place Bid"
                                                                                        fromComponent="home"
                                                                                        showCondition={
                                                                                            false
                                                                                        }
                                                                                        showLocation={
                                                                                            true
                                                                                        }
                                                                                        timerIcon={
                                                                                            true
                                                                                        }
                                                                                        bidStatus={
                                                                                            true
                                                                                        }
                                                                                        setViewProduct={
                                                                                            setViewProduct
                                                                                        }
                                                                                        viewProduct={
                                                                                            viewBuyNow
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }
                                                                })}
                                                        </div>
                                                    )}
                                                </TabPanel>
                                            </>
                                        ) : (
                                            <div
                                                className={
                                                    checkMediaWithPrimeBidTheme || checkEmursTheme
                                                        ? 'searchContainer gridViewPrimebidsMobile'
                                                        : 'searchHomeContainer gf'
                                                }
                                            >
                                                {viewProduct
                                                    ?.filter((ele) => ele.auction == 1)
                                                    ?.map((data, index) => {
                                                        if (index < 28) {
                                                            return (
                                                                <>
                                                                    {!checkMediaWithPrimeBidTheme ||
                                                                    checkEmursTheme ? (
                                                                        <div className="homeGridCard">
                                                                            <GridProduct
                                                                                data={data}
                                                                                className={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                key={index}
                                                                                type={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                selectedProduct={
                                                                                    selectedProduct
                                                                                }
                                                                                link={`/gallery/product-view/${data.id}`}
                                                                                handleClick={
                                                                                    handleClick
                                                                                }
                                                                                timerTheme={
                                                                                    isPrimeBids
                                                                                        ? 'gFThemeTimer'
                                                                                        : ''
                                                                                }
                                                                                sliderTheme="multiseller"
                                                                                cardTheme="liquidationTwo"
                                                                                bidBtnLabel="Place Bid"
                                                                                showCondition={
                                                                                    false
                                                                                }
                                                                                showLocation={true}
                                                                                timerIcon={true}
                                                                                bidStatus={true}
                                                                                setViewProduct={
                                                                                    setViewProduct
                                                                                }
                                                                                viewProduct={
                                                                                    viewProduct
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="lotResults mb-4 liquidationBuyCard">
                                                                            <GridProduct
                                                                                data={data}
                                                                                className={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                key={index}
                                                                                type={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                selectedProduct={
                                                                                    selectedProduct
                                                                                }
                                                                                link={`/gallery/product-view/${data.id}`}
                                                                                handleClick={
                                                                                    handleClick
                                                                                }
                                                                                timerTheme={
                                                                                    isPrimeBids
                                                                                        ? 'gFThemeTimer'
                                                                                        : ''
                                                                                }
                                                                                sliderTheme="multiseller"
                                                                                cardTheme="liquidationTwo"
                                                                                bidBtnLabel="Place Bid"
                                                                                showCondition={
                                                                                    false
                                                                                }
                                                                                showLocation={true}
                                                                                timerIcon={true}
                                                                                bidStatus={true}
                                                                                setViewProduct={
                                                                                    setViewProduct
                                                                                }
                                                                                viewProduct={
                                                                                    viewProduct
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )
                                                        }
                                                    })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="spellbindingDeals position-relative">
                                    {isPrimeBids ? null : (
                                        <h3 className="todayDealsTit">
                                            Today&apos;s Spellbinding Deals
                                        </h3>
                                    )}
                                    {isPrimeBids ? null : (
                                        <div className="searchHomeContainer wizardSearchHomeContainer">
                                            {viewProduct
                                                ?.filter((ele) => ele.auction == 1)
                                                ?.map((data, index) => {
                                                    if (index < 28) {
                                                        return (
                                                            <>
                                                                {!checkMediaWithPrimeBidTheme ? (
                                                                    <div className="homeGridCard">
                                                                        <GridProduct
                                                                            data={data}
                                                                            className={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            key={index}
                                                                            type={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            selectedProduct={
                                                                                selectedProduct
                                                                            }
                                                                            link={`/gallery/product-view/${data.id}`}
                                                                            handleClick={
                                                                                handleClick
                                                                            }
                                                                            timerTheme={
                                                                                isPrimeBids
                                                                                    ? 'gFThemeTimer'
                                                                                    : ''
                                                                            }
                                                                            sliderTheme="multiseller"
                                                                            cardTheme="liquidationTwo"
                                                                            bidBtnLabel="Bid Now"
                                                                            showCondition={false}
                                                                            showLocation={true}
                                                                            timerIcon={true}
                                                                            bidStatus={true}
                                                                            setViewProduct={
                                                                                setViewProduct
                                                                            }
                                                                            viewProduct={
                                                                                viewProduct
                                                                            }
                                                                            showDateNumber={2}
                                                                            details={`search?auctionId=${data.id}`}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div className="lotResults mb-4 liquidationBuyCard">
                                                                        <GridProduct
                                                                            data={data}
                                                                            className={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            key={index}
                                                                            type={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            selectedProduct={
                                                                                selectedProduct
                                                                            }
                                                                            link={`/gallery/product-view/${data.id}`}
                                                                            handleClick={
                                                                                handleClick
                                                                            }
                                                                            timerTheme={
                                                                                isPrimeBids
                                                                                    ? 'gFThemeTimer'
                                                                                    : ''
                                                                            }
                                                                            sliderTheme="multiseller"
                                                                            cardTheme="liquidationTwo"
                                                                            bidBtnLabel="Bid Now"
                                                                            showCondition={false}
                                                                            showLocation={true}
                                                                            timerIcon={true}
                                                                            bidStatus={true}
                                                                            setViewProduct={
                                                                                setViewProduct
                                                                            }
                                                                            viewProduct={
                                                                                viewProduct
                                                                            }
                                                                            showDateNumber={2}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </>
                                                        )
                                                    }
                                                })}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                    {/* {checkBidShopTheme && (
                        <div className="whyUsSection customContainer">
                            <h3>Why Choose Bid2Shop?</h3>
                            <div className="whyUsInner">
                                <div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="75"
                                        height="60"
                                        viewBox="0 0 75 60"
                                        fill="none"
                                    >
                                        <g clipPath="url(#clip0_593_43362)">
                                            <path
                                                d="M14.9998 11.25C18.1053 11.25 20.6248 8.73047 20.6248 5.625C20.6248 2.51953 18.1053 0 14.9998 0C11.8943 0 9.3748 2.51953 9.3748 5.625C9.3748 8.73047 11.8943 11.25 14.9998 11.25ZM59.9998 11.25C63.1053 11.25 65.6248 8.73047 65.6248 5.625C65.6248 2.51953 63.1053 0 59.9998 0C56.8943 0 54.3748 2.51953 54.3748 5.625C54.3748 8.73047 56.8943 11.25 59.9998 11.25ZM74.7303 54.8555L69.574 41.9648L64.7576 47.4023L64.5232 49.5352L67.7693 57.6445C68.3553 59.1094 69.7615 60 71.2498 60C71.7186 60 72.1873 59.918 72.6443 59.7305C74.5662 58.957 75.5037 56.7773 74.7303 54.8555ZM70.7225 30.2695L68.5545 20.8711C68.0154 18.5273 66.3748 16.5586 64.16 15.6094C61.992 14.6719 59.5896 14.8242 57.5857 15.9961C54.9256 17.5664 52.9334 20.0391 51.949 22.957L50.6248 26.9297L48.7498 28.125V16.875C48.7498 15.8438 47.9061 15 46.8748 15H28.1248C27.0936 15 26.2498 15.8438 26.2498 16.875V28.125L24.3631 26.9297L23.0389 22.957C22.0662 20.0273 20.0623 17.5664 17.4021 15.9961C15.3865 14.8242 12.9959 14.6719 10.8279 15.6094C8.61308 16.5586 6.97246 18.5273 6.4334 20.8711L4.27715 30.2695C3.73808 32.6133 4.35918 35.0977 5.96465 36.9141L13.8396 45.8086L15.0232 56.6602C15.2342 58.5703 16.8514 60 18.7498 60C18.8904 60 19.0193 59.9883 19.16 59.9766C21.2225 59.7539 22.699 57.9023 22.4764 55.8398L21.2928 44.9648C21.117 43.4414 20.4842 42.0234 19.4646 40.8633L14.3904 35.1211L16.4529 26.8828L17.2498 29.2734C17.7303 30.7383 18.6443 32.0156 20.1209 33.0938L26.1092 36.9023C26.6482 37.2422 27.5271 37.4414 28.1248 37.4883H46.8748C47.4725 37.4414 48.3514 37.2422 48.8904 36.9023L54.8787 33.0938C56.3553 32.0156 57.2693 30.75 57.7498 29.2734L58.5467 26.8828L60.6092 35.1211L55.535 40.8633C54.5154 42.0234 53.8826 43.4414 53.7068 44.9648L52.5232 55.8398C52.3006 57.9023 53.7889 59.7539 55.8396 59.9766C55.9803 59.9883 56.1092 60 56.2498 60C58.1365 60 59.7654 58.582 59.9764 56.6602L61.16 45.8086L69.035 36.9141C70.6287 35.0977 71.2615 32.6133 70.7225 30.2695ZM5.42558 41.9648L0.269333 54.8555C-0.504104 56.7773 0.433396 58.957 2.35527 59.7305C4.32402 60.5039 6.46855 59.5312 7.23027 57.6445L10.4764 49.5352L10.242 47.4023L5.42558 41.9648Z"
                                                fill="#192E35"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_593_43362">
                                                <rect width="75" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="h5">Shop Local, Pick Up Next Day</div>
                                    <p>
                                        Shopping local means you can pick it up as soon as the next
                                        day.{' '}
                                    </p>
                                </div>
                                <div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="60"
                                        height="48"
                                        viewBox="0 0 60 48"
                                        fill="none"
                                    >
                                        <g clipPath="url(#clip0_593_43356)">
                                            <path
                                                d="M57.7496 0H39.7496C38.5136 0 36.7826 0.717 35.9096 1.59L13.5926 23.907C13.1718 24.3298 12.9355 24.902 12.9355 25.4985C12.9355 26.095 13.1718 26.6672 13.5926 27.09L32.9096 46.407C33.3324 46.8278 33.9046 47.064 34.5011 47.064C35.0976 47.064 35.6698 46.8278 36.0926 46.407L58.4096 24.09C59.2856 23.214 59.9996 21.486 59.9996 20.25V2.25C59.998 1.65375 59.7604 1.08237 59.3388 0.660759C58.9172 0.239145 58.3458 0.00158367 57.7496 0ZM46.4996 18C45.9084 17.9998 45.3231 17.8832 44.7771 17.6568C44.231 17.4304 43.7349 17.0986 43.317 16.6805C42.8991 16.2623 42.5677 15.766 42.3417 15.2198C42.1156 14.6735 41.9994 14.0881 41.9996 13.497C41.9998 12.9059 42.1164 12.3205 42.3428 11.7745C42.5692 11.2284 42.901 10.7323 43.3191 10.3144C43.7372 9.89653 44.2336 9.56512 44.7798 9.33908C45.326 9.11304 45.9114 8.9968 46.5026 8.997C47.6965 8.9974 48.8413 9.47204 49.6852 10.3165C50.5291 11.161 51.003 12.3061 51.0026 13.5C51.0022 14.6939 50.5275 15.8387 49.6831 16.6826C48.8386 17.5265 47.6935 18.0004 46.4996 18Z"
                                                fill="#192E35"
                                            />
                                            <path
                                                d="M5.99959 25.5L31.4996 0H27.7496C26.5136 0 24.7826 0.717 23.9096 1.59L1.59259 23.907C1.17179 24.3298 0.935547 24.902 0.935547 25.4985C0.935547 26.095 1.17179 26.6672 1.59259 27.09L20.9096 46.407C21.3324 46.8278 21.9046 47.064 22.5011 47.064C23.0976 47.064 23.6698 46.8278 24.0926 46.407L25.5026 44.997L6.00259 25.497L5.99959 25.5Z"
                                                fill="#192E35"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_593_43356">
                                                <rect width="60" height="48" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="h5">Don&apos;t Pay Retail</div>
                                    <p>Pay a fraction of retail with bids starting as low as $1</p>
                                </div>
                                <div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="69"
                                        height="60"
                                        viewBox="0 0 69 60"
                                        fill="none"
                                    >
                                        <path
                                            d="M64.2857 38.5714L68.5714 60H0L4.28571 38.5714H12.0536C10.9152 36.6071 10.0558 34.5424 9.47545 32.3772C8.89509 30.2121 8.59375 27.9911 8.57143 25.7143C8.57143 23.3482 8.87277 21.0714 9.47545 18.8839C10.0781 16.6964 10.9487 14.654 12.0871 12.7567C13.2254 10.8594 14.5647 9.1183 16.1049 7.53348C17.6451 5.94866 19.375 4.60938 21.2946 3.51562C23.2143 2.42187 25.2679 1.5625 27.4554 0.9375C29.6429 0.3125 31.9196 0 34.2857 0C36.6518 0 38.9286 0.301339 41.1161 0.904018C43.3036 1.5067 45.346 2.37723 47.2433 3.51562C49.1406 4.65402 50.8817 5.9933 52.4665 7.53348C54.0513 9.07366 55.3906 10.8036 56.4844 12.7232C57.5781 14.6429 58.4375 16.6964 59.0625 18.8839C59.6875 21.0714 60 23.3482 60 25.7143C60 27.9911 59.7098 30.2121 59.1295 32.3772C58.5491 34.5424 57.6786 36.6071 56.5179 38.5714H64.2857ZM55.7143 25.7143C55.7143 25 55.6808 24.2857 55.6138 23.5714C55.5469 22.8571 55.4353 22.1429 55.279 21.4286H46.942C47.0759 22.8795 47.1429 24.308 47.1429 25.7143C47.1429 27.1429 47.0759 28.5714 46.942 30H55.279C55.4129 29.2857 55.5134 28.5714 55.5804 27.8571C55.6473 27.1429 55.692 26.4286 55.7143 25.7143ZM25.9152 30H42.6562C42.7902 28.5714 42.8571 27.1429 42.8571 25.7143C42.8571 24.308 42.7902 22.8795 42.6562 21.4286H25.9152C25.7812 22.8795 25.7143 24.308 25.7143 25.7143C25.7143 27.1429 25.7812 28.5714 25.9152 30ZM42.0536 34.2857H26.5179C26.6071 34.7991 26.7634 35.4688 26.9866 36.2946C27.2098 37.1205 27.4888 38.0246 27.8237 39.0067C28.1585 39.9888 28.5491 40.9487 28.9955 41.8862C29.442 42.8237 29.933 43.6942 30.4687 44.4978C31.0045 45.3013 31.596 45.9375 32.2433 46.4062C32.8906 46.875 33.5714 47.1205 34.2857 47.1429C35 47.1429 35.6696 46.8973 36.2946 46.4062C36.9196 45.9152 37.5112 45.279 38.0692 44.4978C38.6272 43.7165 39.1183 42.846 39.5424 41.8862C39.9665 40.9263 40.3571 39.9665 40.7143 39.0067C41.0714 38.0469 41.3504 37.154 41.5513 36.3281C41.7522 35.5022 41.9196 34.8214 42.0536 34.2857ZM26.0826 45.5022C25.0558 43.8058 24.2299 41.9978 23.6049 40.0781C22.9799 38.1585 22.5 36.2277 22.1652 34.2857H14.6652C15.2009 35.4688 15.8705 36.6183 16.6741 37.7344C17.4777 38.8504 18.3705 39.9107 19.3527 40.9152C20.3348 41.9196 21.4062 42.8013 22.567 43.5603C23.7277 44.3192 24.8996 44.9665 26.0826 45.5022ZM46.4062 34.2857C46.0491 36.2054 45.5692 38.125 44.9665 40.0446C44.3638 41.9643 43.5491 43.7835 42.5223 45.5022C43.7277 44.9665 44.8884 44.308 46.0045 43.5268C47.1205 42.7455 48.1808 41.875 49.1853 40.9152C50.1897 39.9554 51.0938 38.9062 51.8973 37.7679C52.7009 36.6295 53.3705 35.4688 53.9062 34.2857H46.4062ZM53.9062 17.1429C52.7679 14.6205 51.2277 12.3884 49.2857 10.4464C47.3438 8.50446 45.0781 6.99777 42.4888 5.92634C43.5156 7.62277 44.3304 9.4308 44.933 11.3504C45.5357 13.2701 46.0268 15.2009 46.4062 17.1429H53.9062ZM34.2857 4.28571C33.5714 4.28571 32.9018 4.53125 32.2768 5.02232C31.6518 5.51339 31.0603 6.14955 30.5022 6.9308C29.9442 7.71205 29.4531 8.58259 29.029 9.54241C28.6049 10.5022 28.2143 11.4621 27.8571 12.4219C27.5 13.3817 27.2098 14.2746 26.9866 15.1004C26.7634 15.9263 26.6071 16.6071 26.5179 17.1429H42.0536C41.942 16.6295 41.7857 15.9598 41.5848 15.1339C41.3839 14.308 41.1049 13.404 40.7478 12.4219C40.3906 11.4397 40 10.4799 39.5759 9.54241C39.1518 8.60491 38.6607 7.73437 38.1027 6.9308C37.5446 6.12723 36.9531 5.49107 36.3281 5.02232C35.7031 4.55357 35.0223 4.30804 34.2857 4.28571ZM26.0826 5.92634C23.5156 6.99777 21.2612 8.50446 19.3192 10.4464C17.3772 12.3884 15.8259 14.6205 14.6652 17.1429H22.1652C22.5223 15.2009 23.0022 13.2701 23.6049 11.3504C24.2076 9.4308 25.0335 7.62277 26.0826 5.92634ZM13.2924 21.4286C13.1585 22.1429 13.058 22.8571 12.9911 23.5714C12.9241 24.2857 12.8795 25 12.8571 25.7143C12.8571 26.4286 12.8906 27.1429 12.9576 27.8571C13.0246 28.5714 13.1362 29.2857 13.2924 30H21.6295C21.4955 28.5714 21.4286 27.1429 21.4286 25.7143C21.4286 24.308 21.4955 22.8795 21.6295 21.4286H13.2924ZM5.22321 55.7143H63.3482L60.7701 42.8571H53.404C52.1987 44.2188 50.8705 45.4241 49.4196 46.4732C47.9688 47.5223 46.4174 48.4263 44.7656 49.1853C43.1138 49.9442 41.4174 50.5022 39.6763 50.8594C37.9353 51.2165 36.1384 51.4062 34.2857 51.4286C32.4554 51.4286 30.6585 51.2388 28.8951 50.8594C27.1317 50.4799 25.4353 49.9219 23.8058 49.1853C22.1763 48.4487 20.6362 47.5558 19.1853 46.5067C17.7344 45.4576 16.3951 44.2411 15.1674 42.8571H7.80134L5.22321 55.7143Z"
                                            fill="#192E35"
                                        />
                                    </svg>
                                    <div className="h5">Environmental Impact</div>
                                    <p>
                                        Give good quality items a second chance after they’ve been
                                        returned.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )} */}
                    {/* {checkBidShopTheme && (
                        <div className="whyUsSection customContainer">
                            <h3>Why Choose Bid2Shop?</h3>
                            <div className="whyUsInner">
                                <div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="75"
                                        height="60"
                                        viewBox="0 0 75 60"
                                        fill="none"
                                    >
                                        <g clipPath="url(#clip0_593_43362)">
                                            <path
                                                d="M14.9998 11.25C18.1053 11.25 20.6248 8.73047 20.6248 5.625C20.6248 2.51953 18.1053 0 14.9998 0C11.8943 0 9.3748 2.51953 9.3748 5.625C9.3748 8.73047 11.8943 11.25 14.9998 11.25ZM59.9998 11.25C63.1053 11.25 65.6248 8.73047 65.6248 5.625C65.6248 2.51953 63.1053 0 59.9998 0C56.8943 0 54.3748 2.51953 54.3748 5.625C54.3748 8.73047 56.8943 11.25 59.9998 11.25ZM74.7303 54.8555L69.574 41.9648L64.7576 47.4023L64.5232 49.5352L67.7693 57.6445C68.3553 59.1094 69.7615 60 71.2498 60C71.7186 60 72.1873 59.918 72.6443 59.7305C74.5662 58.957 75.5037 56.7773 74.7303 54.8555ZM70.7225 30.2695L68.5545 20.8711C68.0154 18.5273 66.3748 16.5586 64.16 15.6094C61.992 14.6719 59.5896 14.8242 57.5857 15.9961C54.9256 17.5664 52.9334 20.0391 51.949 22.957L50.6248 26.9297L48.7498 28.125V16.875C48.7498 15.8438 47.9061 15 46.8748 15H28.1248C27.0936 15 26.2498 15.8438 26.2498 16.875V28.125L24.3631 26.9297L23.0389 22.957C22.0662 20.0273 20.0623 17.5664 17.4021 15.9961C15.3865 14.8242 12.9959 14.6719 10.8279 15.6094C8.61308 16.5586 6.97246 18.5273 6.4334 20.8711L4.27715 30.2695C3.73808 32.6133 4.35918 35.0977 5.96465 36.9141L13.8396 45.8086L15.0232 56.6602C15.2342 58.5703 16.8514 60 18.7498 60C18.8904 60 19.0193 59.9883 19.16 59.9766C21.2225 59.7539 22.699 57.9023 22.4764 55.8398L21.2928 44.9648C21.117 43.4414 20.4842 42.0234 19.4646 40.8633L14.3904 35.1211L16.4529 26.8828L17.2498 29.2734C17.7303 30.7383 18.6443 32.0156 20.1209 33.0938L26.1092 36.9023C26.6482 37.2422 27.5271 37.4414 28.1248 37.4883H46.8748C47.4725 37.4414 48.3514 37.2422 48.8904 36.9023L54.8787 33.0938C56.3553 32.0156 57.2693 30.75 57.7498 29.2734L58.5467 26.8828L60.6092 35.1211L55.535 40.8633C54.5154 42.0234 53.8826 43.4414 53.7068 44.9648L52.5232 55.8398C52.3006 57.9023 53.7889 59.7539 55.8396 59.9766C55.9803 59.9883 56.1092 60 56.2498 60C58.1365 60 59.7654 58.582 59.9764 56.6602L61.16 45.8086L69.035 36.9141C70.6287 35.0977 71.2615 32.6133 70.7225 30.2695ZM5.42558 41.9648L0.269333 54.8555C-0.504104 56.7773 0.433396 58.957 2.35527 59.7305C4.32402 60.5039 6.46855 59.5312 7.23027 57.6445L10.4764 49.5352L10.242 47.4023L5.42558 41.9648Z"
                                                fill="#192E35"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_593_43362">
                                                <rect width="75" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="h5">Shop Local, Pick Up Next Day</div>
                                    <p>
                                        Shopping local means you can pick it up as soon as the next
                                        day.{' '}
                                    </p>
                                </div>
                                <div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="60"
                                        height="48"
                                        viewBox="0 0 60 48"
                                        fill="none"
                                    >
                                        <g clipPath="url(#clip0_593_43356)">
                                            <path
                                                d="M57.7496 0H39.7496C38.5136 0 36.7826 0.717 35.9096 1.59L13.5926 23.907C13.1718 24.3298 12.9355 24.902 12.9355 25.4985C12.9355 26.095 13.1718 26.6672 13.5926 27.09L32.9096 46.407C33.3324 46.8278 33.9046 47.064 34.5011 47.064C35.0976 47.064 35.6698 46.8278 36.0926 46.407L58.4096 24.09C59.2856 23.214 59.9996 21.486 59.9996 20.25V2.25C59.998 1.65375 59.7604 1.08237 59.3388 0.660759C58.9172 0.239145 58.3458 0.00158367 57.7496 0ZM46.4996 18C45.9084 17.9998 45.3231 17.8832 44.7771 17.6568C44.231 17.4304 43.7349 17.0986 43.317 16.6805C42.8991 16.2623 42.5677 15.766 42.3417 15.2198C42.1156 14.6735 41.9994 14.0881 41.9996 13.497C41.9998 12.9059 42.1164 12.3205 42.3428 11.7745C42.5692 11.2284 42.901 10.7323 43.3191 10.3144C43.7372 9.89653 44.2336 9.56512 44.7798 9.33908C45.326 9.11304 45.9114 8.9968 46.5026 8.997C47.6965 8.9974 48.8413 9.47204 49.6852 10.3165C50.5291 11.161 51.003 12.3061 51.0026 13.5C51.0022 14.6939 50.5275 15.8387 49.6831 16.6826C48.8386 17.5265 47.6935 18.0004 46.4996 18Z"
                                                fill="#192E35"
                                            />
                                            <path
                                                d="M5.99959 25.5L31.4996 0H27.7496C26.5136 0 24.7826 0.717 23.9096 1.59L1.59259 23.907C1.17179 24.3298 0.935547 24.902 0.935547 25.4985C0.935547 26.095 1.17179 26.6672 1.59259 27.09L20.9096 46.407C21.3324 46.8278 21.9046 47.064 22.5011 47.064C23.0976 47.064 23.6698 46.8278 24.0926 46.407L25.5026 44.997L6.00259 25.497L5.99959 25.5Z"
                                                fill="#192E35"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_593_43356">
                                                <rect width="60" height="48" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="h5">Don&apos;t Pay Retail</div>
                                    <p>Pay a fraction of retail with bids starting as low as $1</p>
                                </div>
                                <div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="69"
                                        height="60"
                                        viewBox="0 0 69 60"
                                        fill="none"
                                    >
                                        <path
                                            d="M64.2857 38.5714L68.5714 60H0L4.28571 38.5714H12.0536C10.9152 36.6071 10.0558 34.5424 9.47545 32.3772C8.89509 30.2121 8.59375 27.9911 8.57143 25.7143C8.57143 23.3482 8.87277 21.0714 9.47545 18.8839C10.0781 16.6964 10.9487 14.654 12.0871 12.7567C13.2254 10.8594 14.5647 9.1183 16.1049 7.53348C17.6451 5.94866 19.375 4.60938 21.2946 3.51562C23.2143 2.42187 25.2679 1.5625 27.4554 0.9375C29.6429 0.3125 31.9196 0 34.2857 0C36.6518 0 38.9286 0.301339 41.1161 0.904018C43.3036 1.5067 45.346 2.37723 47.2433 3.51562C49.1406 4.65402 50.8817 5.9933 52.4665 7.53348C54.0513 9.07366 55.3906 10.8036 56.4844 12.7232C57.5781 14.6429 58.4375 16.6964 59.0625 18.8839C59.6875 21.0714 60 23.3482 60 25.7143C60 27.9911 59.7098 30.2121 59.1295 32.3772C58.5491 34.5424 57.6786 36.6071 56.5179 38.5714H64.2857ZM55.7143 25.7143C55.7143 25 55.6808 24.2857 55.6138 23.5714C55.5469 22.8571 55.4353 22.1429 55.279 21.4286H46.942C47.0759 22.8795 47.1429 24.308 47.1429 25.7143C47.1429 27.1429 47.0759 28.5714 46.942 30H55.279C55.4129 29.2857 55.5134 28.5714 55.5804 27.8571C55.6473 27.1429 55.692 26.4286 55.7143 25.7143ZM25.9152 30H42.6562C42.7902 28.5714 42.8571 27.1429 42.8571 25.7143C42.8571 24.308 42.7902 22.8795 42.6562 21.4286H25.9152C25.7812 22.8795 25.7143 24.308 25.7143 25.7143C25.7143 27.1429 25.7812 28.5714 25.9152 30ZM42.0536 34.2857H26.5179C26.6071 34.7991 26.7634 35.4688 26.9866 36.2946C27.2098 37.1205 27.4888 38.0246 27.8237 39.0067C28.1585 39.9888 28.5491 40.9487 28.9955 41.8862C29.442 42.8237 29.933 43.6942 30.4687 44.4978C31.0045 45.3013 31.596 45.9375 32.2433 46.4062C32.8906 46.875 33.5714 47.1205 34.2857 47.1429C35 47.1429 35.6696 46.8973 36.2946 46.4062C36.9196 45.9152 37.5112 45.279 38.0692 44.4978C38.6272 43.7165 39.1183 42.846 39.5424 41.8862C39.9665 40.9263 40.3571 39.9665 40.7143 39.0067C41.0714 38.0469 41.3504 37.154 41.5513 36.3281C41.7522 35.5022 41.9196 34.8214 42.0536 34.2857ZM26.0826 45.5022C25.0558 43.8058 24.2299 41.9978 23.6049 40.0781C22.9799 38.1585 22.5 36.2277 22.1652 34.2857H14.6652C15.2009 35.4688 15.8705 36.6183 16.6741 37.7344C17.4777 38.8504 18.3705 39.9107 19.3527 40.9152C20.3348 41.9196 21.4062 42.8013 22.567 43.5603C23.7277 44.3192 24.8996 44.9665 26.0826 45.5022ZM46.4062 34.2857C46.0491 36.2054 45.5692 38.125 44.9665 40.0446C44.3638 41.9643 43.5491 43.7835 42.5223 45.5022C43.7277 44.9665 44.8884 44.308 46.0045 43.5268C47.1205 42.7455 48.1808 41.875 49.1853 40.9152C50.1897 39.9554 51.0938 38.9062 51.8973 37.7679C52.7009 36.6295 53.3705 35.4688 53.9062 34.2857H46.4062ZM53.9062 17.1429C52.7679 14.6205 51.2277 12.3884 49.2857 10.4464C47.3438 8.50446 45.0781 6.99777 42.4888 5.92634C43.5156 7.62277 44.3304 9.4308 44.933 11.3504C45.5357 13.2701 46.0268 15.2009 46.4062 17.1429H53.9062ZM34.2857 4.28571C33.5714 4.28571 32.9018 4.53125 32.2768 5.02232C31.6518 5.51339 31.0603 6.14955 30.5022 6.9308C29.9442 7.71205 29.4531 8.58259 29.029 9.54241C28.6049 10.5022 28.2143 11.4621 27.8571 12.4219C27.5 13.3817 27.2098 14.2746 26.9866 15.1004C26.7634 15.9263 26.6071 16.6071 26.5179 17.1429H42.0536C41.942 16.6295 41.7857 15.9598 41.5848 15.1339C41.3839 14.308 41.1049 13.404 40.7478 12.4219C40.3906 11.4397 40 10.4799 39.5759 9.54241C39.1518 8.60491 38.6607 7.73437 38.1027 6.9308C37.5446 6.12723 36.9531 5.49107 36.3281 5.02232C35.7031 4.55357 35.0223 4.30804 34.2857 4.28571ZM26.0826 5.92634C23.5156 6.99777 21.2612 8.50446 19.3192 10.4464C17.3772 12.3884 15.8259 14.6205 14.6652 17.1429H22.1652C22.5223 15.2009 23.0022 13.2701 23.6049 11.3504C24.2076 9.4308 25.0335 7.62277 26.0826 5.92634ZM13.2924 21.4286C13.1585 22.1429 13.058 22.8571 12.9911 23.5714C12.9241 24.2857 12.8795 25 12.8571 25.7143C12.8571 26.4286 12.8906 27.1429 12.9576 27.8571C13.0246 28.5714 13.1362 29.2857 13.2924 30H21.6295C21.4955 28.5714 21.4286 27.1429 21.4286 25.7143C21.4286 24.308 21.4955 22.8795 21.6295 21.4286H13.2924ZM5.22321 55.7143H63.3482L60.7701 42.8571H53.404C52.1987 44.2188 50.8705 45.4241 49.4196 46.4732C47.9688 47.5223 46.4174 48.4263 44.7656 49.1853C43.1138 49.9442 41.4174 50.5022 39.6763 50.8594C37.9353 51.2165 36.1384 51.4062 34.2857 51.4286C32.4554 51.4286 30.6585 51.2388 28.8951 50.8594C27.1317 50.4799 25.4353 49.9219 23.8058 49.1853C22.1763 48.4487 20.6362 47.5558 19.1853 46.5067C17.7344 45.4576 16.3951 44.2411 15.1674 42.8571H7.80134L5.22321 55.7143Z"
                                            fill="#192E35"
                                        />
                                    </svg>
                                    <div className="h5">Environmental Impact</div>
                                    <p>
                                        Give good quality items a second chance after they’ve been
                                        returned.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )} */}

                    <div className="customContainer auctions  position-relative">
                        {/* {!isAuthenticated && checkThemeClassName ? (
                            <div className="stkyContent">
                                <div className="textConte">
                                    <h4 className="mb-3">
                                        Want to view all the <span className="auction">lots?</span>
                                    </h4>
                                    <p className="mb-0">
                                        <PrimaryButton
                                            customClassName="buttonClass"
                                            onClick={() => history.push('/login')}
                                        >
                                            Login/Register
                                        </PrimaryButton>
                                    </p>
                                </div>
                            </div>
                        ) : null} */}
                        <div className={`auctionEndingSoon position-relative`}>
                            <h3 className="todayDealsTit">Auction Ending Soon</h3>

                            {filteredAuctions.length ? (
                                <>
                                    {isWizardTheme ? (
                                        <div className="slider-container" ref={containerRef}>
                                            <Slider {...settingsWizard}>
                                                {filteredAuctions.map((data, index) => (
                                                    <>
                                                        <MultisellerListCard
                                                            data={data}
                                                            key={index}
                                                            details={`search?auctionId=${data.id}`}
                                                            card_theme="liquidationTwo"
                                                            handleLotClick={handleWizardClick}
                                                        />
                                                    </>
                                                ))}
                                            </Slider>
                                        </div>
                                    ) : (
                                        filteredAuctions.map((data, index) => (
                                            <MultisellerListCard
                                                data={data}
                                                key={index}
                                                details={`search/product-buyer-auction/${data.id}`}
                                                card_theme="liquidationTwo"
                                                handleLotClick={handleClick}
                                            />
                                        ))
                                    )}
                                </>
                            ) : (
                                <NoRecordsFound />
                            )}
                        </div>
                    </div>
                    {!bodyClass && (
                        <div className="customContainer locationSection">
                            <div className="locations position-relative">
                                <h3 className="todayDealsTit">Locations</h3>
                                <div className="wizardLocations">
                                    {allLocations?.length > 0 ? (
                                        <>
                                            {allLocations.map((val) => (
                                                <WorkingHours locations={val} />
                                            ))}
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {!isWizardTheme && !LiquidityProject ? (
                        <>
                            {checkThemeClassName || !checkEmursTheme ? (
                                <div className="customContainer howItSection">
                                    <div className="pmEllipseContainer d-flex align-items-center pt-5 pb-5">
                                        <div className="PmEllipse">
                                            <span className="material-icons-outlined">info</span>
                                        </div>
                                        <h3>Learn more</h3>
                                    </div>

                                    <div className="info-section">
                                        {/* Left Column */}
                                        <div className="info-text">
                                            <h2>How it works</h2>
                                            <div className="info-details">
                                                <div className="info-row">
                                                    <span className="info-title">
                                                        Win your item:
                                                    </span>
                                                    <span className="info-description">
                                                        Bid, win, and pay for your items.
                                                    </span>
                                                </div>
                                                <div className="info-row">
                                                    <span className="info-title">
                                                        Get notified:
                                                    </span>
                                                    <span className="info-description">
                                                        Notifications will come through email and in
                                                        your account once items are prepared for
                                                        pickup. <em>(No walk-ins)</em>
                                                    </span>
                                                </div>
                                                <div className="info-row">
                                                    <span className="info-title">Pick up:</span>
                                                    <span className="info-description">
                                                        You get 5 days from the point of
                                                        notification to pick up your items.{' '}
                                                        <em>Please ensure prompt payment</em>
                                                    </span>
                                                </div>
                                            </div>

                                            <h2>What’s in it for you?</h2>
                                            <div className="benefits">
                                                <div className="benefit-card">
                                                    <h4>
                                                        Less <br />
                                                        waiting
                                                    </h4>
                                                    <p>Items will be ready when you arrive.</p>
                                                </div>
                                                <div className="benefit-card">
                                                    <h4>
                                                        Clear <br />
                                                        communication
                                                    </h4>
                                                    <p>You’ll know when the items are ready.</p>
                                                </div>
                                                <div className="benefit-card">
                                                    <h4>
                                                        Improved <br />
                                                        efficiency
                                                    </h4>
                                                    <p>A smoother pickup process for everyone.</p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Right Column */}
                                        <div className="info-video">
                                            <h2>Learn more about what we do</h2>
                                            <div className="video-placeholder">
                                                {' '}
                                                <video width={350} height={320} controls>
                                                    <source
                                                        src="/assets/video/demoPrimebids.mp4"
                                                        type="video/mp4"
                                                    ></source>
                                                </video>
                                            </div>
                                            <div className="d-flex justify-content-end align-items-center">
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/how_it_works"
                                                    className=""
                                                >
                                                    {' '}
                                                    Visit{' '}
                                                    <span className="hiwLink">
                                                        how it works
                                                    </span>{' '}
                                                    for more information about what we do.
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="31"
                                                        height="30"
                                                        viewBox="0 0 31 30"
                                                        fill="none"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M16.8238 8.49582C17.0816 8.23802 17.4996 8.23802 17.7574 8.49582L23.7325 14.4709C23.9903 14.7287 23.9903 15.1467 23.7325 15.4045L17.7574 21.3796C17.4996 21.6374 17.0816 21.6374 16.8238 21.3796C16.566 21.1217 16.566 20.7038 16.8238 20.4459L21.6719 15.5979H8.32806C7.96346 15.5979 7.6679 15.3023 7.6679 14.9377C7.6679 14.5731 7.96346 14.2775 8.32806 14.2775L21.6719 14.2775L16.8238 9.42943C16.566 9.17162 16.566 8.75363 16.8238 8.49582Z"
                                                            fill="#222222"
                                                        />
                                                    </svg>
                                                </NavLink>{' '}
                                                &nbsp;
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : checkEmursTheme ? null : (
                                <div className="hiwContainer">
                                    <h2 className="divHdrTxt text-center">
                                        {checkBeachThemeClassName ? 'Why Choose Us' : 'What we do'}
                                    </h2>
                                    {checkBeachThemeClassName ? (
                                        <>
                                            <div className="customContainer whyUsBeach">
                                                <div>
                                                    <img src="/assets/images/Why_us_page_image.png" />
                                                    <ul>
                                                        <li>
                                                            <b>Unrivaled Product Range: </b>From
                                                            single items to bulk lots, we&apos;ve
                                                            got it all. Need one item or a hundred?
                                                            We&apos;ve got you covered!
                                                        </li>
                                                        <li>
                                                            <b>Flexible Buying Options: </b>Shop
                                                            online or in-person - the choice is
                                                            yours!
                                                        </li>
                                                        <li>
                                                            <b>Transparent Pricing: </b>No hidden
                                                            fees, no surprises. Just honest,
                                                            competitive prices.
                                                        </li>
                                                        <li>
                                                            <b>Immediate Pick-up: </b>Why wait? Get
                                                            your items right away!
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="customContainer whtWeDo">
                                            <div className="PmHiwBase-root">
                                                <div className="PmHiwVideoDetails-root">
                                                    <ul>
                                                        <li>
                                                            {global?.storeDetails?.site_id ===
                                                            'AS0698'
                                                                ? 'At PRIME BIDS, '
                                                                : ' '}
                                                            We buy returned and overstocked goods
                                                            from top retailers and sell them in
                                                            online auctions.
                                                        </li>
                                                        <li>
                                                            Some items start at $1, while others
                                                            begin with discounts of 5-15% off retail
                                                            prices.
                                                        </li>
                                                        <li>
                                                            We have over 10,000 winners each WEEK.
                                                        </li>
                                                        <li>
                                                            Did you win? Schedule a pick up
                                                            appointment so your items are ready to
                                                            go.
                                                        </li>
                                                        <li>
                                                            Learn how to Bid, Win & Save up to 80%
                                                            off retail prices in this video also
                                                            visit our
                                                            <NavLink
                                                                activeClassName="active"
                                                                to="/how_it_works"
                                                            >
                                                                {' '}
                                                                How it works
                                                            </NavLink>{' '}
                                                            for more details
                                                        </li>
                                                    </ul>
                                                    {/* <a href="#">Read Our FAQ&apos;s to Learn More</a> */}
                                                </div>
                                                <div className="PmHiwVideo-root">
                                                    <video width={350} height={320} controls>
                                                        <source
                                                            src="/assets/video/demoPrimebids.mp4"
                                                            type="video/mp4"
                                                        ></source>
                                                    </video>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            {!bodyClass && (
                                <div className="splEvntsWrpr">
                                    <div className="customContainer pb-4">
                                        {checkThemeClassName || checkEmursTheme ? (
                                            <div className={checkEmursTheme ? 'seperator' : null}>
                                                {' '}
                                                <div className="pmEllipseContainer d-flex align-items-center pt-5 pb-5">
                                                    <div className="PmEllipse">
                                                        <span className="material-icons-outlined">
                                                            priority_high
                                                        </span>
                                                    </div>
                                                    <h3>Special Events</h3>
                                                </div>
                                                <div className="vwActnWrapper">
                                                    {viewAuction.length ? (
                                                        <div className="hmActnLstWrpr">
                                                            {viewAuction.map((data, index) => (
                                                                <MultisellerListCard
                                                                    data={data}
                                                                    key={index}
                                                                    details={`search/product-buyer-auction/${data.id}`}
                                                                    card_theme="liquidationTwo"
                                                                    handleLotClick={handleClick}
                                                                />
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <NoRecordsFound />
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                {' '}
                                                <h2 className="divHdrTxt text-center">
                                                    SPECIAL EVENTS
                                                </h2>
                                                <div className="vwActnWrapper">
                                                    {viewAuction.length ? (
                                                        <div className="hmActnLstWrpr">
                                                            {viewAuction.map((data, index) => (
                                                                <MultisellerListCard
                                                                    data={data}
                                                                    key={index}
                                                                    details={`search/product-buyer-auction/${data.id}`}
                                                                    card_theme="liquidationTwo"
                                                                />
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <NoRecordsFound />
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {checkEmursTheme || checkThemeClassName || bodyClass ? null : (
                                <div className="splEvntsWrpr">
                                    <div className="customContainer pb-4">
                                        <h2 className="divHdrTxt text-center">SPECIAL EVENTS</h2>
                                        <div className="vwActnWrapper">
                                            {viewAuction.length ? (
                                                <div className="hmActnLstWrpr">
                                                    {viewAuction.map((data, index) => (
                                                        <MultisellerListCard
                                                            data={data}
                                                            key={index}
                                                            details={`search/product-buyer-auction/${data.id}`}
                                                            card_theme="liquidationTwo"
                                                        />
                                                    ))}
                                                </div>
                                            ) : (
                                                <NoRecordsFound />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {global?.pluginConfiguration?.google_reviews?.enable == 1 ? (
                                <div className="googleReviewPoint mt-4">
                                    <div className="customContainer pb-4">
                                        <h3>Our Reviews</h3>
                                        {checkThemeClassName ? (
                                            <ReactGoogleReviews
                                                layout="carousel"
                                                featurableId={
                                                    process.env.REACT_APP_FEATURABLE_PLUGIN_ID
                                                }
                                            />
                                        ) : (
                                            <Reviews />
                                        )}
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                            {global?.storeConfigration?.fact_to_know?.value == 0 ||
                            checkEmursTheme ? null : (
                                <>
                                    {global?.storeDetails?.fact_to_know ? (
                                        <div className="faqContainer yu">
                                            <div className="customContainer py-4">
                                                <h2 className="divHdrTxt">
                                                    Facts to know{' '}
                                                    <Link
                                                        to="/faq"
                                                        className="extnlLnk cursorDecoy"
                                                    >
                                                        VIEW FAQS
                                                    </Link>
                                                </h2>
                                                <div className="fqLst">
                                                    {' '}
                                                    {ReactHtmlParser(
                                                        global.storeDetails.fact_to_know,
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="faqContainer">
                                            <div className="customContainer py-4">
                                                <h2 className="divHdrTxt">
                                                    Facts to know{' '}
                                                    <Link
                                                        to="/faq"
                                                        className="extnlLnk cursorDecoy"
                                                    >
                                                        VIEW FAQS
                                                    </Link>
                                                </h2>
                                                <div className="fqLst">
                                                    <ul>
                                                        <li>
                                                            Most items have a starting bid of $5
                                                        </li>
                                                        <li>
                                                            Prices increase by our bid increments as
                                                            bids are placed
                                                        </li>
                                                        <li>
                                                            We’ll notify you via text and/or email
                                                            if you’ve been outbid
                                                        </li>
                                                        <li>
                                                            Credit cards are charged automatically
                                                            for any winnings at the end of the
                                                            auction
                                                        </li>
                                                    </ul>
                                                    <ul>
                                                        <li>
                                                            You have 7 days for local pickup item
                                                            retrieval
                                                        </li>
                                                        <li>
                                                            We offer Refunds, please view our Policy
                                                            for more details
                                                        </li>
                                                        <li>
                                                            An 11% Buyer’s Premium applies to all
                                                            sales
                                                        </li>
                                                        <li>
                                                            We collect Sales Tax unless you provide
                                                            a valid California Resale License
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="hiwContainer">
                                        <h2 className="divHdrTxt text-center">
                                            {checkBeachThemeClassName
                                                ? 'Why Choose Us'
                                                : 'What we do'}
                                        </h2>
                                        {checkBeachThemeClassName ? (
                                            <>
                                                <div className="customContainer whyUsBeach">
                                                    <div>
                                                        <img src="/assets/images/Why_us_page_image.png" />
                                                        <ul>
                                                            <li>
                                                                <b>Unrivaled Product Range: </b>
                                                                From single items to bulk lots,
                                                                we&apos;ve got it all. Need one item
                                                                or a hundred? We&apos;ve got you
                                                                covered!
                                                            </li>
                                                            <li>
                                                                <b>Flexible Buying Options: </b>
                                                                Shop online or in-person - the
                                                                choice is yours!
                                                            </li>
                                                            <li>
                                                                <b>Transparent Pricing: </b>No
                                                                hidden fees, no surprises. Just
                                                                honest, competitive prices.
                                                            </li>
                                                            <li>
                                                                <b>Immediate Pick-up: </b>Why wait?
                                                                Get your items right away!
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="customContainer whtWeDo">
                                                <div className="PmHiwBase-root">
                                                    <div className="PmHiwVideoDetails-root">
                                                        <ul>
                                                            <li>
                                                                {global?.storeDetails?.site_id ===
                                                                'AS0698'
                                                                    ? 'At PRIME BIDS, '
                                                                    : ' '}
                                                                We buy returned and overstocked
                                                                goods from top retailers and sell
                                                                them in online auctions.
                                                            </li>
                                                            <li>
                                                                Some items start at $1, while others
                                                                begin with discounts of 5-15% off
                                                                retail prices.
                                                            </li>
                                                            <li>
                                                                We have over 10,000 winners each
                                                                WEEK.
                                                            </li>
                                                            <li>
                                                                Did you win? Schedule a pick up
                                                                appointment so your items are ready
                                                                to go.
                                                            </li>
                                                            <li>
                                                                Learn how to Bid, Win & Save up to
                                                                80% off retail prices in this video
                                                                also visit our
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/how_it_works"
                                                                >
                                                                    {' '}
                                                                    How it works
                                                                </NavLink>{' '}
                                                                for more details
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="PmHiwVideo-root">
                                                        <video width={350} height={320} controls>
                                                            <source
                                                                src="/assets/video/demoPrimebids.mp4"
                                                                type="video/mp4"
                                                            ></source>
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {!bodyClass && (
                                        <div className="splEvntsWrpr">
                                            <div className="customContainer pb-4">
                                                <h2 className="divHdrTxt text-center">
                                                    SPECIAL EVENTS
                                                </h2>
                                                <div className="vwActnWrapper">
                                                    {viewAuction.length ? (
                                                        <div className="hmActnLstWrpr">
                                                            {viewAuction.map((data, index) => (
                                                                <MultisellerListCard
                                                                    data={data}
                                                                    key={index}
                                                                    details={`search/product-buyer-auction/${data.id}`}
                                                                    card_theme="liquidationTwo"
                                                                />
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <NoRecordsFound />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {global?.pluginConfiguration?.google_reviews?.enable == 1 ? (
                                        <div className="googleReviewPoint mt-4">
                                            <div className="customContainer pb-4">
                                                <h3>Our Reviews</h3>

                                                <Reviews />
                                            </div>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    {global?.storeConfigration?.fact_to_know?.value == 0 ? null : (
                                        <>
                                            {' '}
                                            {global?.storeDetails?.fact_to_know ? (
                                                <div className="faqContainer">
                                                    <div className="customContainer py-4">
                                                        <h2 className="divHdrTxt">
                                                            Facts to know{' '}
                                                            <Link
                                                                to="/faq"
                                                                className="extnlLnk cursorDecoy"
                                                            >
                                                                VIEW FAQS
                                                            </Link>
                                                        </h2>
                                                        <div className="fqLst">
                                                            {' '}
                                                            {ReactHtmlParser(
                                                                global.storeDetails.fact_to_know,
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="faqContainer">
                                                    <div className="customContainer py-4">
                                                        <h2 className="divHdrTxt">
                                                            Facts to know{' '}
                                                            <Link
                                                                to="/faq"
                                                                className="extnlLnk cursorDecoy"
                                                            >
                                                                VIEW FAQS
                                                            </Link>
                                                        </h2>
                                                        <div className="fqLst">
                                                            <ul>
                                                                <li>
                                                                    Most items have a starting bid
                                                                    of $5
                                                                </li>
                                                                <li>
                                                                    Prices increase by our bid
                                                                    increments as bids are placed
                                                                </li>
                                                                <li>
                                                                    We’ll notify you via text and/or
                                                                    email if you’ve been outbid
                                                                </li>
                                                                <li>
                                                                    Credit cards are charged
                                                                    automatically for any winnings
                                                                    at the end of the auction
                                                                </li>
                                                            </ul>
                                                            <ul>
                                                                <li>
                                                                    You have 7 days for local pickup
                                                                    item retrieval
                                                                </li>
                                                                <li>
                                                                    We offer Refunds, please view
                                                                    our Policy for more details
                                                                </li>
                                                                <li>
                                                                    An 11% Buyer’s Premium applies
                                                                    to all sales
                                                                </li>
                                                                <li>
                                                                    We collect Sales Tax unless you
                                                                    provide a valid California
                                                                    Resale License
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {global?.storeConfigration?.subscribe?.value && (
                                                <div className="homeContact">
                                                    <h2>Get the latest deals</h2>
                                                    <p>Subscribe us to get latest updates</p>
                                                    <div className="subsBox">
                                                        <input
                                                            type="text"
                                                            name="q"
                                                            value={inpData}
                                                            placeholder="Enter email address"
                                                            onChange={(e) => {
                                                                setinpData(e.target.value)
                                                            }}
                                                        />
                                                        <Button>
                                                            <span
                                                                className="material-icons"
                                                                onClick={subscribe}
                                                            >
                                                                send
                                                            </span>
                                                        </Button>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    ) : null}
                    {LiquidityProject ? (
                        <>
                            <div className="splEvntsWrpr">
                                <div className="customContainer pb-4">
                                    <div>
                                        {' '}
                                        <h2 className="divHdrTxt text-center">SPECIAL EVENTS</h2>
                                        <div className="vwActnWrapper">
                                            {viewAuction.length ? (
                                                <div className="hmActnLstWrpr">
                                                    {viewAuction.map((data, index) => (
                                                        <MultisellerListCard
                                                            data={data}
                                                            key={index}
                                                            details={`search/product-buyer-auction/${data.id}`}
                                                            card_theme="liquidationTwo"
                                                        />
                                                    ))}
                                                </div>
                                            ) : (
                                                <NoRecordsFound />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="faqContainer">
                                <div className="customContainer py-4">
                                    <h2 className="divHdrTxt">
                                        Facts to know{' '}
                                        <Link to="/faq" className="extnlLnk cursorDecoy">
                                            VIEW FAQS
                                        </Link>
                                    </h2>
                                    <div className="fqLst">
                                        <ul>
                                            <li>Most items have a starting bid of $5</li>
                                            <li>
                                                Prices increase by our bid increments as bids are
                                                placed
                                            </li>
                                            <li>
                                                We’ll notify you via text and/or email if you’ve
                                                been outbid
                                            </li>
                                            <li>
                                                Credit cards are charged automatically for any
                                                winnings at the end of the auction
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>You have 7 days for local pickup item retrieval</li>
                                            <li>
                                                We offer Refunds, please view our Policy for more
                                                details
                                            </li>
                                            <li>An 11% Buyer’s Premium applies to all sales</li>
                                            <li>
                                                We collect Sales Tax unless you provide a valid
                                                California Resale License
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                </>
            </div>
            <MultisellerSlider
                selectedLot={selectedProduct}
                handleClose={handleClose}
                currency="cad"
                type={props.type ? props.type : ''}
                storeTheme="Liquidation_two"
                pvTabList={true}
            />
        </Layout>
    )
}

export default Home
